import React, { Component, PropTypes } from "react";
import {
    Select,
    Form,
    Input,
    Button,
    Layout,
    DatePicker,
    Timeline,
    Tag,
    Icon,
    Tabs,
    Avatar,
    Card,
    Spin,
    Alert
} from "antd";
import { RaisedButton } from "material-ui";
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng
} from "react-places-autocomplete";
import TimeInput from "react-time-input";
import { Map } from "immutable";
import {
    Map as MapLeftlet,
    Marker,
    TileLayer,
    Tooltip,
    Popup,
    Polyline
} from "react-leaflet";
import { style } from "../style";
import * as actions from "../../../actions";
import * as srv from "../../../services";
import {
    parseAvatarText,
    parseUsername,
    parseTimeFromNow,
    getDistanceFromLatLonInKm,
    iconGsm,
    iconPark,
    iconRun,
    iconStop
} from "../util";
import { SelectUser, SelectDevices } from "../../itracking";
import PopupMentions from "./popupMentions";
import Leaflet from "leaflet";
import MediaQuery from "react-responsive";
import * as colors from "material-ui/styles/colors";

//import google api
import GoogleMapsLoader from "google-maps";

//Config locate
import moment from "moment";
import "moment/locale/vi";

moment.locale("vi");

let google;

GoogleMapsLoader.load(function(goo) {
    google = goo;
});

const FormItem = Form.Item;
const { Footer, Sider, Content } = Layout;
const { CheckableTag } = Tag;
const TabPane = Tabs.TabPane;
const position = [10.766685, 106.684709];
const keyApi = "AIzaSyAxZVwP4oiId0OxqGlwA1y6VNN4DWTh4Gk";
const URL = "https://api.dinhviso.com.vn/";

class MarkerOpenPopup extends Marker {
    componentDidMount() {
        super.componentDidMount();

        this.leafletElement.openPopup();
    }
}

export default class PopupEvent extends Component {
    constructor(props) {
        super(props);

        if (this.props.slot.id) {
            this.state = {
                id: this.props.slot.id,
                subject: this.genSubjectByProps(),
                projectID: this.props.slot.projectID
                    ? this.props.slot.projectID
                    : this.props.curProjectID,
                trackerID: this.props.slot.trackerID,
                trackerName: this.props.slot.trackerName,
                assignedToID: this.props.slot.assignedToID,
                engineerID: this.props.slot.engineerID
                    ? this.props.slot.engineerID
                    : 0,
                saleID: this.props.slot.saleID,
                assignedName: this.props.slot.assignedName,
                assignedMore: this.props.slot.assignedMore,
                engineerMore: this.props.slot.engineerMore,
                trackerMore: this.props.slot.trackerMore,
                start: this.props.slot.start
                    ? this.props.slot.start
                    : new Date(this.props.slot.startDate),
                end: this.props.slot.end
                    ? this.props.slot.end
                    : new Date(this.props.slot.dueDate),
                statusID: this.props.slot.statusID,
                description: this.props.slot.description
                    ? this.props.slot.description
                    : "",
                priorityID: this.props.slot.priorityID
                    ? this.props.slot.priorityID
                    : 3,
                authorID: this.props.slot.authorID
                    ? this.props.slot.authorID
                    : 0,
                createdOn: this.props.slot.createdOn
                    ? this.props.slot.createdOn
                    : "",
                bounds:
                    this.props.slot.latitude && this.props.slot.longitude
                        ? [
                              [
                                  this.props.slot.latitude,
                                  this.props.slot.longitude
                              ]
                          ]
                        : [
                              [20.9591091, 105.3436084],
                              [10.7827413, 106.5560123]
                          ],
                history: [],
                currentTab: 1,
                commentText: "",
                commentInput: "",
                clientID: this.props.slot.clientID
                    ? this.props.slot.clientID
                    : 0,
                username: this.props.slot.username
                    ? this.props.slot.username
                    : "",
                clientDetailID: this.props.slot.clientDetailID
                    ? this.props.slot.clientDetailID
                    : 0,
                latitude: this.props.slot.latitude,
                longitude: this.props.slot.longitude,
                clientAddress: this.props.slot.clientAddress
                    ? this.props.slot.clientAddress
                    : "",
                contactPhone: this.props.slot.contactPhone
                    ? this.props.slot.contactPhone
                    : "",
                contactName: this.props.slot.contactName
                    ? this.props.slot.contactName
                    : "",
                preClientDetailID: 0,
                saveClientDetail: false,
                devices: [],
                defaultDevices: this.props.slot.defaultDevices
                    ? this.props.slot.defaultDevices
                    : "",
                loading: false,
                alert: [],
                mentionUsers: [],
                viewTech: Map({}),
                arrSuggest: [],
                waitingRoute: false,
                waitingPostComment: false,
                showMaps: true
            };
        } else {
            let user = this.props.account.user;

            let isSeller;
            if (user && user.groups) {
                isSeller = user.groups["Seller"] ? true : false;
            }

            let now = moment().format("YYYY-MM-DD");
            let start = this.props.slot.start
                ? this.props.slot.start
                : new Date(`${now} 07:00:00`);
            let end = this.props.slot.end
                ? this.props.slot.end
                : new Date(`${now} 07:30:00`);

            this.state = {
                start: start,
                end: end,
                projectID: this.props.curProjectID,
                authorID: this.props.account.user.id
                    ? this.props.account.user.id
                    : 0,
                authorName: this.props.account.user
                    ? parseUsername(
                          this.props.account.user.firstname,
                          this.props.account.user.lastname
                      )
                    : "",
                saleID: isSeller ? this.props.account.user.id : 0,
                statusID: 1,
                history: [],
                currentTab: 1,
                commentText: "",
                clientID: 0,
                clientDetailID: this.props.slot.clientDetailID
                    ? this.props.slot.clientDetailID
                    : 0,
                preClientDetailID: 0,
                saveClientDetail: false,
                devices: [],
                defaultDevices: "",
                loading: false,
                alert: [],
                contactName: "",
                clientAddress: "",
                contactPhone: "",
                preClientAddress: "",
                preContactPhone: "",
                preContactName: "",
                description: "",
                mentionUsers: [],
                commentInput: "",
                viewTech: Map({}),
                arrSuggest: [],
                waitingRoute: false,
                waitingPostComment: false,
                showMaps: true
            };
        }

        this.handleSelect = this.handleSelect.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.setSelectedUserID = this.setSelectedUserID.bind(this);
    }

    static propTypes = {
        issuesMap: PropTypes.object,
        usersMap: PropTypes.object,
        trackersMap: PropTypes.object,
        overviewByTrackers: PropTypes.array,
        curProjectID: PropTypes.number,
        account: PropTypes.object,
        token: PropTypes.string
    };

    static defaultProps = {
        issuesMap: Map,
        usersMap: Map,
        trackersMap: Map,
        account: {},
        overviewByTrackers: [],
        curProjectID: 0,
        token: ""
    };

    componentWillMount() {
        this.initTech();

        let curWidth = window.innerWidth;
        if (curWidth >= 1224) {
            this.setState({ showMaps: true });
        } else {
            this.setState({ showMaps: false });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.wailtingSaveIssue === true) {
            this.setState({ wailtingSaveIssue: false });
        }
    }

    componentDidMount() {
        if (this.props.usersMap && this.props.usersMap.size > 0) {
            if (this.state.mentionUsers.length === 0) {
                let mentionUsers = this.props.usersMap.map(user => {
                    let userJS = user.toJS();
                    if (userJS) {
                        let userID = userJS.id;

                        userJS.userID = userID;
                        userJS.id = userJS.mail
                            ? `${userID}#${userJS.mail}`
                            : `null${userID}`;
                        userJS.display = parseUsername(
                            userJS.firstname,
                            userJS.lastname
                        );
                    }

                    return userJS;
                });

                this.setState({
                    mentionUsers: mentionUsers.toArray()
                });
            }
        }
    }

    componentDidUpdate() {
        let tagsFilterUser = document.querySelectorAll(
            ".filter-select .ant-select-selection__choice"
        );
        if (tagsFilterUser && tagsFilterUser.length > 0) {
            for (let tag of tagsFilterUser) {
                let user = this.props.usersMap.filter(
                    user =>
                        parseUsername(
                            user.get("firstname"),
                            user.get("lastname")
                        ) === tag.title
                );
                if (user._root) {
                    let color = user.get(user._root.entries[0][0]).get("color");
                    if (user.size > 0 && color) {
                        tag.style.backgroundColor = color;
                    }
                }
            }
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state !== nextState) {
            return true;
        }

        if (this.props.slot !== nextProps.slot) {
            return true;
        }

        if (this.props.techLocation !== nextProps.techLocation) {
            return true;
        }

        return false;
    }

    withExistsTech() {
        let bounds = [];
        let mapUserAsg = Map({});
        let userAsg = this.props.usersMap.get(
            this.props.slot.assignedToID
                ? this.props.slot.assignedToID.toString()
                : ""
        );

        if (userAsg && userAsg.get("deviceID")) {
            mapUserAsg = mapUserAsg.set(userAsg.get("deviceID"), userAsg);
        }

        if (
            this.props.slot.assignedMore &&
            this.props.slot.assignedMore.length > 0
        ) {
            let arrUserAsgID = this.props.slot.assignedMore.split(",");

            if (arrUserAsgID && arrUserAsgID.length > 0) {
                arrUserAsgID.map(userID => {
                    let userAsg = this.props.usersMap.get(userID.toString());

                    if (userAsg && userAsg.get("deviceID")) {
                        mapUserAsg = mapUserAsg.set(
                            userAsg.get("deviceID"),
                            userAsg
                        );
                    }
                });
            }
        }

        if (this.props.techLocation.size > 0) {
            this.props.techLocation.map(location => {
                if (mapUserAsg.get(location.id)) {
                    let roadmaps = location.roadmaps;

                    if (roadmaps && roadmaps.length > 0) {
                        let latitude = roadmaps[roadmaps.length - 1].latitude;
                        let longitude = roadmaps[roadmaps.length - 1].longitude;

                        if (latitude && longitude) {
                            bounds.push([latitude, longitude]);
                        }
                    }
                }
            });

            if (bounds.length > 0) {
                bounds.push(...this.state.bounds);
            }
        }

        this.setState({ viewTech: mapUserAsg, bounds });
    }

    noneTech() {
        let today = moment().format("YYYY-MM-DD");
        let startDateSlot = moment(this.props.slot.startDate).format(
            "YYYY-MM-DD"
        );
        let startTimeSlot = this.props.slot.startTime;
        let unixSLotStartDate = moment(
            `${startDateSlot} ${startTimeSlot}`
        ).unix();
        let unixNow = moment().unix();

        if (unixSLotStartDate < unixNow) {
            return;
        }

        let freeTech = this.props.techLocation;
        let arrSuggest = [];

        this.props.issuesMap.map(issueMap => {
            let startDate = issueMap.get("startDate");
            let startTime = issueMap.get("startTime")
                ? issueMap.get("startTime")
                : "08:00:00";

            if (startDate) {
                let mStartDate = moment(startDate).format("YYYY-MM-DD");
                let unixStartDate = moment(`${mStartDate} ${startTime}`).unix();

                if (mStartDate === startDateSlot) {
                    let assingedID = issueMap.get("assignedToID");
                    let statusID = issueMap.get("statusID");

                    if (assingedID && assingedID > 0 && statusID === 7) {
                        let infoTech = this.props.usersMap.get(
                            assingedID.toString()
                        );

                        if (infoTech) {
                            let deviceID = infoTech.get("deviceID");

                            if (deviceID && deviceID.length > 0) {
                                freeTech = freeTech.delete(deviceID.toString());
                            }
                        }

                        if (unixSLotStartDate - unixStartDate > 1800) {
                            let issue = issueMap.toJS();

                            if (issue.latitude && issue.longitude) {
                                let kmDistance = getDistanceFromLatLonInKm(
                                    this.props.slot.latitude,
                                    this.props.slot.longitude,
                                    issue.latitude,
                                    issue.longitude
                                );

                                issue.type = "issue";
                                issue.kmDistance = kmDistance;

                                arrSuggest.push(issue);
                            }
                        }
                    }
                }
            }
        });

        if (freeTech.size > 0) {
            freeTech.map(techInfo => {
                let roadmaps = techInfo.roadmaps;

                if (roadmaps && roadmaps.length > 0) {
                    let latitude = roadmaps[roadmaps.length - 1].latitude;
                    let longitude = roadmaps[roadmaps.length - 1].longitude;
                    let status = roadmaps[roadmaps.length - 1].status;

                    if (latitude && longitude) {
                        let kmDistance = getDistanceFromLatLonInKm(
                            this.props.slot.latitude,
                            this.props.slot.longitude,
                            latitude,
                            longitude
                        );

                        techInfo.type = "tech";
                        techInfo.kmDistance = kmDistance;
                        techInfo.latitude = latitude;
                        techInfo.longitude = longitude;
                        techInfo.status = status;

                        arrSuggest.push(techInfo);
                    }
                }
            });
        }

        if (arrSuggest.length > 0) {
            arrSuggest.sort(function(a, b) {
                if (a.kmDistance && b.kmDistance) {
                    return a.kmDistance - b.kmDistance;
                }

                return -1;
            });

            let suggest = arrSuggest[0];

            suggest.index = 0;

            let bounds = [];

            if (suggest.latitude && suggest.longitude) {
                bounds.push([suggest.latitude, suggest.longitude]);
            }

            if (this.props.slot.latitude && this.props.slot.longitude) {
                bounds.push([
                    this.props.slot.latitude,
                    this.props.slot.longitude
                ]);
            }

            this.setState({ arrSuggest, suggest, bounds });
        }
    }

    initTech() {
        if (this.props.slot.statusID !== 7) {
            return;
        }

        if (this.props.slot.assignedToID && this.props.slot.assignedToID > 0) {
            this.withExistsTech();
        } else {
            if (this.props.slot.latitude && this.props.slot.longitude) {
                let user = this.props.account.user;

                if (
                    !user.groups ||
                    user.groups === null ||
                    user.groups.length === 0
                ) {
                    return false;
                }

                let isManager = !!user.groups["Manager"];
                if (isManager) {
                    this.noneTech();
                }
            }
        }
    }

    genSubjectByProps() {
        let subject = ``;

        if (this.props.slot.statusID && this.props.slot.statusID > 0) {
            subject += `${this.statusDefaultValue(
                this.props.slot.statusID,
                true
            )} `;
        }

        if (this.props.slot.username && this.props.slot.username.length > 0) {
            subject += `- ${this.props.slot.username} `;
        }

        if (
            this.props.slot.trackerName &&
            this.props.slot.trackerName.length > 0
        ) {
            subject += `- ${this.props.slot.trackerName} `;
        }

        if (this.props.slot.saleID && this.props.slot.saleID > 0) {
            let sale = this.props.usersMap.get(
                this.props.slot.saleID.toString()
            );

            if (sale) {
                let firstname = sale.get("firstname");
                let lastname = sale.get("lastname");

                subject += `- ${parseUsername(firstname, lastname)} `;
            }
        }

        return subject;
    }

    genSubjectByState() {
        let subject = ``;

        if (this.state.statusID && this.state.statusID > 0) {
            subject += `${this.statusDefaultValue(this.state.statusID, true)} `;
        }

        if (this.state.username && this.state.username.length > 0) {
            subject += `- ${this.state.username} `;
        }

        if (this.state.trackerName && this.state.trackerName.length > 0) {
            subject += `- ${this.state.trackerName} `;
        }

        if (this.state.saleID && this.state.saleID > 0) {
            let sale = this.props.usersMap.get(this.state.saleID.toString());

            if (sale) {
                let firstname = sale.get("firstname");
                let lastname = sale.get("lastname");

                subject += `- ${parseUsername(firstname, lastname)} `;
            }
        }

        return subject;
    }

    async initHistory() {
        if (this.state.id && this.state.id > 0) {
            const data = await srv.getissueHistory(this.state.id);
            if (data.history && data.history.length > 0) {
                let historyMap = Map();
                let stateHistory = [];

                data.history.map(history => {
                    let tempHistory = historyMap.get(history.id.toString());

                    if (tempHistory) {
                        stateHistory = stateHistory.map(historyArr => {
                            if (historyArr.id == tempHistory.id) {
                                historyArr.moreDetail = this.getHistoryDetail(
                                    history,
                                    historyArr.moreDetail
                                );
                            }
                            return historyArr;
                        });
                    } else {
                        history.moreDetail = this.getHistoryDetail(history);
                        stateHistory.push(history);
                        historyMap = historyMap.set(
                            history.id.toString(),
                            history
                        );
                    }
                });

                stateHistory.sort(function(history, nextHistory) {
                    if (history.createdOn && nextHistory.createdOn) {
                        return (
                            moment(nextHistory.createdOn).unix() -
                            moment(history.createdOn).unix()
                        );
                    }

                    return -1;
                });

                this.setState({ history: stateHistory });
            }
        }
    }

    srvDeleteIssue() {
        let bToken = `Bearer ${this.props.token}`;

        return fetch(
            `${URL}teamweek/issues/${this.props.curProjectID}/${this.state.id}`,
            {
                method: "DELETE",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: bToken
                }
            }
        ).then(response => {
            let alert = this.state.alert;

            if (response.status === 200) {
                let issue = {
                    id: this.state.id
                };

                this.props.dispatch(actions.removeIssueToMap(issue));
                this.props.handleCloseModal();

                return response.json();
            } else {
                alert.push("error");

                this.setState({ loading: false, alert });

                return {
                    status: response.status,
                    message: response.statusText
                };
            }
        });
    }

    deleteEvent() {
        this.setState({ loading: true });
        this.srvDeleteIssue();
    }

    async saveEvent(assignedID) {
        this.setState({ wailtingSaveIssue: true, loading: true });

        let issue = this.state;

        if (assignedID) {
            issue.assignedToID = assignedID;
        }

        if (!issue.startTime) {
            issue.startTime = moment(issue.start).format("HH:mm");
        }

        if (!issue.dueTime) {
            issue.dueTime = moment(issue.end).format("HH:mm");
        }

        issue.issueDevices = issue.devices.map(device => {
            if (parseInt(device.id) !== 0) {
                let deviceID = device.id;

                device.deviceID = deviceID;
                device.id = 0;
            }

            device.activation = moment(device.activation).format(
                "YYYY-MM-DD HH:mm:ss"
            );

            return device;
        });

        if (issue.statusID === 8 && issue.engineerID === 0) {
            let user = this.props.account.user;
            if (user.groups && user.groups["Manager"]) {
                issue.engineerID = this.props.account.user.id;
            }
        }

        if (issue.start) {
            issue.startDate = moment(issue.start).format("YYYY-MM-DD");
        }

        if (issue.end) {
            issue.dueDate = moment(issue.end).format("YYYY-MM-DD");
        }

        if (typeof issue.startDate !== "string") {
            issue.startDate = moment(issue.startDate).format("YYYY-MM-DD");
        }

        if (typeof issue.dueDate !== "string") {
            issue.dueDate = moment(issue.dueDate).format("YYYY-MM-DD");
        }

        issue.subject = this.genSubjectByState();

        delete issue.mentionUsers;
        delete issue.loading;
        delete issue.bounds;
        delete issue.viewTech;
        delete issue.suggest;
        delete issue.arrSuggest;

        let data = await this.srvSaveIssue(issue);

        if (data && data.issue && data.issue.id > 0) {
            this.setState({ id: data.issue.id });
            this.props.dispatch(actions.saveNewEventMap(data.issue));
        }
    }

    srvSaveIssue(issue) {
        let bToken = `Bearer ${this.props.token}`;

        return fetch(`${URL}teamweek/issues/${this.props.curProjectID}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: bToken
            },
            body: JSON.stringify(issue)
        }).then(response => {
            let alert = this.state.alert;

            if (response.status === 200) {
                alert.push("success");

                this.setState({ loading: false, alert });

                return response.json();
            } else {
                alert.push("error");

                this.setState({ loading: false, alert });

                return {
                    status: response.status,
                    message: response.statusText
                };
            }
        });
    }

    handleChange(value, name) {
        switch (name) {
            case "description":
                this.setState({ [name]: value.target.value });
                break;

            case "clientAddress":
                if (this.state.clientAddress.length === 0 && value.length > 0) {
                    this.setState({ [name]: value });
                } else {
                    if (this.state.clientDetailID > 0) {
                        if (this.state.saveClientDetail) {
                            this.setState({ [name]: value, clientDetailID: 0 });
                        } else {
                            if (
                                this.state.preClientDetailID ===
                                this.state.clientDetailID
                            ) {
                                if (this.state.clientAddress !== value) {
                                    this.setState({
                                        [name]: value,
                                        clientDetailID: 0,
                                        saveClientDetail: true
                                    });
                                }
                            } else {
                                this.setState({ [name]: value });
                            }
                        }
                    } else {
                        this.setState({
                            [name]: value,
                            saveClientDetail: true
                        });
                    }
                }

                break;

            case "assignedToID":
                if (value.length === 0) {
                    this.setState({
                        assignedToID: 0,
                        assignedName: "",
                        assignedMore: ""
                    });
                } else if (value.length === 1) {
                    this.setState({
                        assignedToID: parseInt(value[0].key),
                        assignedName: value[0].label,
                        assignedMore: ""
                    });
                } else {
                    let initAssignedUser = value.splice(0, 1);
                    let assignedMore = value
                        .map(assignedUser => assignedUser.key)
                        .join(",");

                    if (initAssignedUser && initAssignedUser.length > 0) {
                        this.setState({
                            assignedToID: parseInt(initAssignedUser[0].key),
                            assignedName: initAssignedUser[0].label,
                            assignedMore: assignedMore
                        });
                    }
                }
                break;

            case "engineerID":
                if (value.length > 0) {
                    let initEngineerUser = value.splice(0, 1);
                    let engineerMore = value
                        .map(engineerUser => engineerUser.key)
                        .join(",");

                    if (initEngineerUser && initEngineerUser.length > 0) {
                        this.setState({
                            engineerID: parseInt(initEngineerUser[0].key),
                            engineerMore: engineerMore
                        });
                    }
                } else if (value.length === 1) {
                    this.setState({
                        engineerID: parseInt(value[0].key),
                        engineerMore: ""
                    });
                } else {
                    this.setState({ engineerID: 0, engineerMore: "" });
                }
                break;

            case "saleID":
                let initAssignedUser = value.splice(0, 1);

                if (initAssignedUser && initAssignedUser.length > 0) {
                    this.setState({
                        saleID: parseInt(initAssignedUser[0].key)
                    });
                }

                break;

            case "trackerID":
                if (value.length === 0) {
                    this.setState({
                        trackerID: 0,
                        trackerName: "",
                        trackerMore: ""
                    });
                } else if (value.length === 1) {
                    this.setState({
                        trackerID: parseInt(value[0].key),
                        trackerName: value[0].label,
                        trackerMore: ""
                    });
                } else {
                    let initTracker = value.splice(0, 1);
                    let trackerMore = value
                        .map(tracker => tracker.key)
                        .join(",");

                    if (initTracker && initTracker.length > 0) {
                        this.setState({
                            trackerID: parseInt(initTracker[0].key),
                            trackerName: initTracker[0].label,
                            trackerMore: trackerMore
                        });
                    }
                }
                break;

            case "startTime":
                const arrTimeStart = value.split(":");
                if (arrTimeStart.length === 2) {
                    let start = moment(this.state.start)
                        .hours(parseInt(arrTimeStart[0]))
                        .minutes(arrTimeStart[1])
                        .toDate();
                    this.setState({ [name]: value, start: start });
                }
                break;

            case "startDate":
                let start, end, curStart, curEnd;

                if (this.state.start instanceof moment) {
                    curStart = this.state.start;
                } else {
                    curStart = moment(this.state.start);
                }

                if (this.state.end instanceof moment) {
                    curEnd = this.state.end;
                } else {
                    curEnd = moment(this.state.end);
                }

                let hoursStart = curStart.hours();
                let minutesStart = curStart.minutes();
                start = moment(value)
                    .hours(hoursStart ? hoursStart : 7)
                    .minutes(minutesStart ? minutesStart : 0)
                    .toDate();

                let hoursEnd = curEnd.hours();
                let minutesEnd = curEnd.minutes();
                end = moment(value)
                    .hours(hoursEnd ? hoursEnd : 7)
                    .minutes(minutesEnd ? minutesEnd : 0)
                    .toDate();

                this.setState({ start, end, startDate: value, dueDate: value });
                break;

            case "dueTime":
                const arrTimeEnd = value.split(":");
                if (arrTimeEnd.length === 2) {
                    let end = moment(this.state.end)
                        .hours(parseInt(arrTimeEnd[0]))
                        .minutes(arrTimeEnd[1])
                        .toDate();
                    this.setState({ [name]: value, end: end });
                }
                break;

            case "statusID":
                this.setState({
                    statusID: parseInt(value.key)
                });
                break;

            case "contactPhoneUpdate":
                this.setState({ contactPhone: value });
                break;

            case "contactNameUpdate":
                this.setState({ contactName: value });
                break;

            case "contactPhone":
                let inputValue = value.target ? value.target.value : "";
                let phoneNumber = parseInt(inputValue);
                if (phoneNumber > 0) {
                    this.setState({
                        contactPhone: "0" + phoneNumber.toString(),
                        clientDetailID: 0,
                        saveClientDetail: true
                    });
                } else {
                    this.setState({ contactPhone: "" });
                }

                break;

            case "contactName":
                let contactNameValue = value.target ? value.target.value : "";
                this.setState({
                    contactName: contactNameValue,
                    clientDetailID: 0,
                    saveClientDetail: true
                });

                break;

            case "saveClientDetail":
                if (value !== undefined) {
                    if (value === true) {
                        this.setState({
                            clientDetailID: 0,
                            clientAddress: "",
                            contactPhone: "",
                            contactName: "",
                            latitude: 0,
                            longitude: 0,
                            saveClientDetail: value
                        });
                    } else {
                        this.setState({ saveClientDetail: value });
                    }
                }
                break;

            case "client":
                if (value !== undefined) {
                    this.setState({
                        client: value,
                        username: value.username ? value.username : ""
                    });
                }
                break;

            case "devices":
                let contentSMS = this.genSms(value);
                if (value) {
                    this.setState({ devices: value, contentSMS: contentSMS });
                }

                break;

            case "clientDetailID":
                if (value > 0) {
                    let clientDetailID = this.state.clientDetailID;

                    this.setState({
                        clientDetailID: value,
                        preClientDetailID: clientDetailID
                    });
                } else {
                    this.setState({
                        clientDetailID: 0,
                        contactName: "",
                        contactPhone: "",
                        clientAddress: "",
                        latitude: 0,
                        longitude: 0
                    });
                }

                break;

            case "savedHistory":
                if (value) {
                    let savedHistory = value;
                    let stateHistory = this.state.history;
                    let user = this.props.usersMap.get(
                        savedHistory.userID.toString()
                    );

                    if (savedHistory) {
                        savedHistory.propKey = "comment";
                        if (user) {
                            savedHistory.firstname = user.get("firstname");
                            savedHistory.lastname = user.get("lastname");
                        } else {
                            savedHistory.firstname = "";
                            savedHistory.lastname = "";
                        }
                        savedHistory.moreDetail = this.getHistoryDetail(
                            savedHistory
                        );

                        stateHistory = [savedHistory, ...stateHistory];
                    }

                    this.setState({ commentInput: "", history: stateHistory });
                }

                break;

            default:
                if (value !== undefined) {
                    this.setState({ [name]: value });
                }

                break;
        }
    }

    saleDefaultValue = () => {
        let saleInfo = this.props.usersMap.get(this.state.saleID.toString());
        if (saleInfo) {
            return {
                key: saleInfo.get("id").toString(),
                label: parseUsername(
                    saleInfo.get("firstname"),
                    saleInfo.get("lastname")
                )
            };
        }

        return undefined;
    };

    userDefaultValue = () => {
        let arrUserDefault = [];

        if (this.state.assignedToID && this.state.assignedName) {
            arrUserDefault.push({
                key: this.state.assignedToID.toString(),
                label: parseUsername(
                    this.props.usersMap
                        .get(this.state.assignedToID.toString())
                        .get("firstname"),
                    this.props.usersMap
                        .get(this.state.assignedToID.toString())
                        .get("lastname")
                )
            });
        }

        if (this.state.assignedMore && this.state.assignedMore.length > 0) {
            const arrAssignedMore = this.state.assignedMore.split(",");
            if (arrAssignedMore && arrAssignedMore.length > 0) {
                const userDefaultMore = arrAssignedMore.map(userID => {
                    return {
                        key: this.props.usersMap
                            .get(userID)
                            .get("id")
                            .toString(),
                        label: parseUsername(
                            this.props.usersMap.get(userID).get("firstname"),
                            this.props.usersMap.get(userID).get("lastname")
                        )
                    };
                });

                if (userDefaultMore && userDefaultMore.length > 0) {
                    return arrUserDefault.concat(userDefaultMore);
                }
            }
        }

        return arrUserDefault;
    };

    trackerDefaultValue = () => {
        let arrTrackerDefault = [];

        if (this.state.trackerID && this.state.trackerName) {
            arrTrackerDefault.push({
                key: this.state.trackerID.toString(),
                label: this.state.trackerName
            });
        }

        if (this.state.trackerMore && this.state.trackerMore.length > 0) {
            const arrTrackerMore = this.state.trackerMore.split(",");
            if (arrTrackerMore && arrTrackerMore.length > 0) {
                let trackerDefaultMore = [];
                arrTrackerMore.map(trackerID => {
                    this.props.overviewByTrackers.map(tracker => {
                        if (tracker.trackerID === parseInt(trackerID)) {
                            trackerDefaultMore.push({
                                key: trackerID,
                                label: tracker.name
                            });
                        }
                    });
                });

                if (trackerDefaultMore && trackerDefaultMore.length > 0) {
                    return arrTrackerDefault.concat(trackerDefaultMore);
                }
            }
        }

        return arrTrackerDefault;
    };

    statusDefaultValue = (statusID, needName) => {
        let name = "";
        switch (statusID) {
            case 1:
                name = "Chờ Duyệt";
                break;
            case 2:
                name = "Đang Thực Hiện";
                break;
            case 3:
                name = "Hoàn Thành";
                break;
            case 4:
                name = "Đợi Phản Hồi";
                break;
            case 5:
                name = "Hủy";
                break;
            case 6:
                name = "Từ Chối";
                break;
            case 7:
                name = "Bảo Trì";
                break;
            case 8:
                name = "Đang Xử Lý";
                break;
        }

        return needName
            ? name
            : {
                  key: statusID.toString(),
                  label: name
              };
    };

    addZero(i) {
        if (i < 10) {
            i = "0" + i;
        }
        return i;
    }

    saleAccess() {
        let user = this.props.account.user;
        let isSeller = user.groups["Seller"] ? true : false;

        if (isSeller) {
            return false;
        }
        return true;
    }

    cantAccess(authorID, needManagerAccess) {
        let user = this.props.account.user;
        if (!user.groups || user.groups === null || user.groups.length === 0) {
            return false;
        }

        let isManager = user.groups["Manager"] ? true : false;
        if (isManager) {
            return true;
        }

        let isTechnical = user.groups["Technical"] ? true : false;
        if (isTechnical && !needManagerAccess) {
            return false;
        }

        let iEngineer = user.groups["Engineer"] ? true : false;
        if (iEngineer && !needManagerAccess) {
            if (this.state.engineerID === user.id) {
                return true;
            }
        }

        let isSeller = user.groups["Seller"] ? true : false;
        if (isSeller && !needManagerAccess) {
            if (authorID === user.id) {
                return true;
            }
        }

        return false;
    }

    handleSelect(address) {
        this.setState({ clientAddress: address, loading: true });

        geocodeByAddress(address)
            .then(results => getLatLng(results[0]))
            .then(({ lat, lng }) => {
                let bounds = [];

                if (this.state.bounds && this.state.bounds.length > 0) {
                    this.state.bounds.map(bound => {
                        if (bound && bound.length === 2) {
                            if (
                                bound[0] !== this.state.latitude &&
                                bound[1] !== this.state.longitude
                            ) {
                                bounds.push(bound);
                            }
                        }
                    });
                }

                this.setState({
                    latitude: lat,
                    longitude: lng,
                    loading: false,
                    bounds: [...bounds, [lat, lng]]
                });
            })
            .catch(error => {
                console.log("Error :", error);
                this.setState({ loading: false });
            });
    }

    updatePosition = () => {
        const { lat, lng } = this.refs.marker.leafletElement.getLatLng();
        const clientAddress = `${lat}, ${lng}`;

        geocodeByAddress(clientAddress)
            .then(results => {
                if (results && results.length > 0) {
                    let bounds = [];

                    if (this.state.bounds && this.state.bounds.length > 0) {
                        this.state.bounds.map(bound => {
                            if (bound && bound.length === 2) {
                                if (
                                    bound[0] !== this.state.latitude &&
                                    bound[1] !== this.state.longitude
                                ) {
                                    bounds.push(bound);
                                }
                            }
                        });
                    }

                    this.setState({
                        clientAddress: results[0].formatted_address,
                        latitude: lat,
                        longitude: lng,
                        bounds: [...bounds, [lat, lng]]
                    });
                }
            })
            .catch(error => {
                console.log("Error :", error);
                this.setState({ loading: false });
            });
    };

    getPropName(propKey) {
        switch (propKey) {
            case "start_date":
                return "Ngày bắt đầu";

            case "due_date":
                return "Ngày kết thúc";

            case "subject":
                return "Tiêu đề";

            default:
                return propKey;
        }
    }

    getUserName() {
        let user = this.props.usersMap.get(this.state.engineerID.toString());
        user = user.toObject();
        if (user) {
            return parseUsername(user.firstname, user.lastname);
        }

        return "";
    }

    getHistoryDetail(history, curDetail) {
        {
            let fullName = "";
            let relativeTime = "";
            let moreDetail;
            let user = this.props.usersMap.get(history.userID.toString());

            user = user.toObject();
            if (user) {
                fullName = parseUsername(user.firstname, user.lastname);
            }

            if (history.createdOn && history.createdOn.length > 0) {
                relativeTime = parseTimeFromNow(history.createdOn);
            }

            switch (history.propKey) {
                case "tracker_id":
                    let oldTrackerName = this.props.trackersMap.get(
                        history.oldValue
                    );
                    let trackerName = this.props.trackersMap.get(history.value);
                    moreDetail = (
                        <li
                            style={{
                                listStyleType: "disc",
                                marginLeft: "16px"
                            }}
                        >
                            Vấn đề thay đổi từ : {oldTrackerName}
                            <Icon
                                type="arrow-right"
                                style={{
                                    paddingRight: "6px"
                                }}
                            />
                            {trackerName}
                        </li>
                    );
                    break;

                case "client_address":
                    moreDetail = (
                        <li
                            style={{
                                listStyleType: "disc",
                                marginLeft: "16px"
                            }}
                        >
                            Địa chỉ thay đổi từ : {history.oldValue}
                            <Icon
                                type="arrow-right"
                                style={{
                                    paddingRight: "6px"
                                }}
                            />
                            {history.value}
                        </li>
                    );
                    break;

                case "description":
                    moreDetail = (
                        <li
                            style={{
                                listStyleType: "disc",
                                marginLeft: "16px"
                            }}
                        >
                            Mô tả thay đổi từ : {history.oldValue}
                            <Icon
                                type="arrow-right"
                                style={{
                                    paddingRight: "6px"
                                }}
                            />
                            {history.value}
                        </li>
                    );
                    break;

                case "comment":
                    moreDetail = <p>{history.value}</p>;
                    break;

                case "sms":
                    moreDetail = <p>{history.value}</p>;
                    break;

                case "status_id":
                    let oldStatus = this.statusDefaultValue(
                        parseInt(history.oldValue)
                    );
                    let status = this.statusDefaultValue(
                        parseInt(history.value)
                    );
                    moreDetail = (
                        <li
                            style={{
                                listStyleType: "disc",
                                marginLeft: "16px"
                            }}
                        >
                            Trạng thái thay đổi từ : {oldStatus.label}
                            <Icon
                                type="arrow-right"
                                style={{
                                    paddingRight: "6px"
                                }}
                            />
                            {status.label}
                        </li>
                    );
                    break;

                case "assigned_to_id":
                    let userMap = this.props.usersMap.get(history.value);
                    if (userMap && userMap.size > 0) {
                        let fullName = "";
                        let firstname = userMap.get("firstname");
                        let lastname = userMap.get("lastname");
                        let checkName = firstname.split(" ");

                        if (checkName && checkName.length > 1) {
                            fullName = firstname;
                        } else {
                            fullName = `${firstname} ${lastname}`;
                        }

                        moreDetail = (
                            <li
                                style={{
                                    listStyleType: "disc",
                                    marginLeft: "16px"
                                }}
                            >
                                Issue được gán cho
                                <strong>{fullName}</strong>
                            </li>
                        );
                    }
                    break;

                default:
                    moreDetail = (
                        <li
                            style={{
                                listStyleType: "disc",
                                marginLeft: "16px"
                            }}
                        >
                            <span
                                style={{
                                    textTransform: "capitalize"
                                }}
                            >
                                {this.getPropName(history.propKey)}
                            </span>
                            thay đổi từ {history.oldValue}
                            <Icon
                                type="arrow-right"
                                style={{
                                    paddingRight: "6px"
                                }}
                            />
                            {history.value}
                        </li>
                    );
                    break;
            }

            if (curDetail) {
                return (
                    <span>
                        {curDetail}
                        {moreDetail ? moreDetail : null}
                    </span>
                );
            }

            return moreDetail ? moreDetail : null;
        }
    }

    setSelectedUserID(selectedUserID) {
        this.setState({ clientID: selectedUserID });
    }

    async sendSMS() {
        if (!this.state.contentSMS) {
            return;
        }

        this.setState({ wailtingSendSms: true });

        let commentText = this.state.contentSMS;
        if (commentText.length === 0) {
            return;
        }

        let commenTo = this.state.assignedToID.toString();
        if (this.state.assignedMore && this.state.assignedMore.length > 0) {
            commenTo += `,${this.state.assignedMore}`;
        }

        let comment = {
            issueID: this.state.id,
            from: parseUsername(
                this.props.account.user.firstname,
                this.props.account.user.lastname
            ),
            to: commenTo.split(","),
            text: commentText,
            type: "sms"
        };

        let data = await srv.postComment(comment, this.props.token);
        if (data && data.status === 200) {
            let savedHistory = data.history;
            let stateHistory = this.state.history;
            let user = this.props.usersMap.get(savedHistory.userID.toString());

            if (savedHistory) {
                savedHistory.propKey = "sms";
                if (user) {
                    savedHistory.firstname = user.get("firstname");
                    savedHistory.lastname = user.get("lastname");
                } else {
                    savedHistory.firstname = "";
                    savedHistory.lastname = "";
                }
                savedHistory.moreDetail = this.getHistoryDetail(savedHistory);

                stateHistory = [savedHistory, ...stateHistory];
            }

            this.setState({
                contentSMS: "",
                history: stateHistory,
                wailtingSendSms: false
            });
        } else {
            this.setState({ wailtingSendSms: false });
        }
    }

    genSms(beforeStateDevices) {
        const issue = this.state;

        let startTime = moment().format("DD-MM-YYYY");
        let deviceName = [];
        let stringDevice = "";
        let devices = [];

        if (beforeStateDevices && beforeStateDevices.length > 0) {
            devices = beforeStateDevices;
        } else {
            devices = issue.devices;
        }

        if (issue.start) {
            let issueStartDate = moment(issue.start).format("DD-MM-YYYY");

            if (startTime === issueStartDate) {
                startTime = moment(issue.start).format("HH:mm");
            } else {
                let tomorrow = moment()
                    .add(1, "days")
                    .format("DD-MM-YYYY");

                if (issueStartDate === tomorrow) {
                    startTime = `Ngày mai ${moment(issue.start).format(
                        "HH:mm"
                    )}`;
                } else {
                    startTime = moment(issue.start).format("DD-MM-YYYY HH:mm");
                }
            }
        }

        if (devices && devices.length > 0) {
            devices.map(device => {
                if (device && device.name.length > 0) {
                    deviceName.push(device.name);
                }
            });
        }

        if (deviceName.length > 0) {
            stringDevice = deviceName.join(", ");
        }

        let contentSMS = `${startTime} `;

        if (issue.username && issue.username.length > 0) {
            contentSMS += `- ${issue.username}: ${stringDevice} `;
        }

        if (issue.trackerName && issue.trackerName.length > 0) {
            contentSMS += `- ${issue.trackerName} `;
        }

        if (issue.description.length > 0) {
            contentSMS += `- ${issue.description} `;
        }

        if (
            issue.contactName.length > 0 ||
            issue.clientAddress.length > 0 ||
            issue.contactPhone.length > 0
        ) {
            contentSMS += `- ${issue.clientAddress} - ${issue.contactName} - ${
                issue.contactPhone
            }`;
        }

        return contentSMS.trim();
    }

    getEngineerDefault() {
        let arrUserDefault = [];

        if (this.state.engineerID && this.state.engineerID > 0) {
            let user = this.props.usersMap.get(
                this.state.engineerID.toString()
            );
            if (user) {
                let groupID = user.get("groupId");
                if (groupID === 75) {
                    arrUserDefault.push({
                        key: this.state.engineerID.toString(),
                        label: this.getUserName()
                    });
                }
            }
        }

        if (this.state.engineerMore && this.state.engineerMore.length > 0) {
            const arrEngineerMore = this.state.engineerMore.split(",");
            if (arrEngineerMore && arrEngineerMore.length > 0) {
                const userDefaultMore = arrEngineerMore.map(userID => {
                    let user = this.props.usersMap.get(userID);

                    if (user) {
                        return {
                            key: user.get("id").toString(),
                            label: parseUsername(
                                user.get("firstname"),
                                user.get("lastname")
                            )
                        };
                    }
                });

                if (userDefaultMore && userDefaultMore.length > 0) {
                    return arrUserDefault.concat(userDefaultMore);
                }
            }
        }

        return arrUserDefault;
    }

    getTooltipInfo(issue) {
        return (
            <span
                style={{
                    textTransform: "capitalize"
                }}
            >
                {issue.startTime ? issue.startTime : this.props.slot.startTime}
                - {issue.username}
                {issue.saleID ? ` - ${this.getHeaderName(issue.saleID)}` : ""}
            </span>
        );
    }

    parseSmsStatus(smsStatus) {
        switch (smsStatus) {
            case 1:
                return "Đang gửi";
            case 2:
                return "Tạm thời không gửi được";
            case 5:
                return "Gửi thành công";
            default:
                return "Không thành công";
        }
    }

    displayClientDetail() {
        if (this.state.saveClientDetail) {
            return "block";
        }

        if (this.state.clientDetailID > 0) {
            return "block";
        }

        return "none";
    }

    getTechName(deviceID) {
        const users = this.props.usersMap
            .filter(user => user.get("deviceID") === deviceID)
            .toArray();

        if (users && users.length > 0) {
            return parseUsername(
                users[0].get("firstname"),
                users[0].get("lastname")
            );
        }

        return "";
    }

    getStatusIcon(status) {
        switch (status) {
            case 1:
                return iconStop;
            case 2:
                return iconPark;
            case 3:
                return iconRun;
        }

        return iconGsm;
    }

    getStatusName(status) {
        switch (status) {
            case 1:
                return "Đỗ";
            case 2:
                return "Dừng";
            case 3:
                return "Đang chạy";
            case 5:
                return "Mất GPS";
        }

        return "Mất GSM";
    }

    getBounds() {
        if (this.state.bounds && this.state.bounds.length > 0) {
            return this.state.bounds;
        } else if (this.props.slot.latitude && this.props.slot.longitude) {
            return [[this.props.slot.latitude, this.props.slot.longitude]];
        }

        return [[20.9591091, 105.3436084], [10.7827413, 106.5560123]];
    }

    nextSuggest = () => {
        if (this.state.suggest) {
            let index = this.state.suggest.index + 1;
            let bounds = [];

            if (index > this.state.arrSuggest.length - 1) {
                index = 0;
            }

            let nextSuggest = this.state.arrSuggest[index];

            nextSuggest.index = index;

            if (this.props.slot.latitude && this.props.slot.longitude) {
                bounds.push([
                    this.props.slot.latitude,
                    this.props.slot.longitude
                ]);
            }

            if (nextSuggest.latitude && nextSuggest.longitude) {
                bounds.push([nextSuggest.latitude, nextSuggest.longitude]);
            }

            this.setState({ suggest: nextSuggest, bounds });
        }
    };

    getColorByAssignedID(assignedToID) {
        if (assignedToID && assignedToID > 0) {
            let user = this.props.usersMap.get(assignedToID.toString());

            if (user && user.get("color")) {
                return user.get("color");
            }
        }

        return colors.grey500;
    }

    getHeaderName(userID) {
        if (userID) {
            let user = this.props.usersMap.get(userID.toString());

            if (user) {
                return parseUsername(
                    user.get("firstname"),
                    user.get("lastname")
                );
            }
        }

        return <Icon type="user" />;
    }

    renderSuggestMarker() {
        if (!this.props.slot.latitude || !this.props.slot.longitude) {
            return null;
        }

        let color = "#ccc";
        let end = new google.maps.LatLng(
            this.props.slot.latitude,
            this.props.slot.longitude
        );

        if (this.state.suggest.type === "issue") {
            let issue = this.state.suggest;
            if (!issue.assignedToID || issue.assignedToID === 0) {
                return null;
            }

            let userAssigned = this.props.usersMap.get(
                issue.assignedToID.toString()
            );
            color = userAssigned.get("color");

            if (issue.latitude && issue.longitude) {
                let start = new google.maps.LatLng(
                    issue.latitude,
                    issue.longitude
                );

                if (this.state.suggest && !this.state.waitingRoute) {
                    this.setState({ waitingRoute: true });
                    this.routeDirections(start, end);
                }
            }

            return (
                <MarkerOpenPopup
                    icon={Leaflet.divIcon({
                        className: `leaftlet-div-icon`,
                        iconAnchor: [0, 24],
                        labelAnchor: [-6, 0],
                        popupAnchor: [0, -36],
                        html: `<span style="background-color: ${this.getColorByAssignedID(
                            issue.assignedToID
                        )};z-index: 100"> <i class="material-icons">build</i> <div class="marker-icon-border"></div> </span> <div class="marker-tranform"></div> `
                    })}
                    ref="marker"
                    position={[issue.latitude, issue.longitude]}
                >
                    <Tooltip
                        className="maps-tooltip"
                        direction="center"
                        offset={[-5, -10]}
                        opacity={1}
                        permanent
                    >
                        <span
                            style={{
                                color: "#111"
                            }}
                        >
                            <span
                                style={{
                                    textTransform: "capitalize"
                                }}
                            >
                                {issue.startTime}
                                - {issue.username}
                                {issue.saleID
                                    ? ` - ${this.getHeaderName(issue.saleID)}`
                                    : ""}
                            </span>
                        </span>
                    </Tooltip>

                    <Popup ref={"popupMarker"}>
                        <div
                            style={{
                                width: "301px"
                            }}
                        >
                            <div
                                style={{
                                    background: color,
                                    padding: "3px",
                                    textAlign: "center",
                                    color: "#fff",
                                    borderTopLeftRadius: "4px",
                                    borderTopRightRadius: "4px",
                                    fontWeight: 600
                                }}
                            >
                                {this.state.suggest.realKm}
                                - {this.state.suggest.duration}
                            </div>

                            <div
                                style={{
                                    padding: "10px 10px 0px 10px"
                                }}
                            >
                                <div
                                    style={{
                                        paddingTop: "5px"
                                    }}
                                >
                                    <strong
                                        style={{
                                            display: "inline-flex",
                                            paddingRight: "10px"
                                        }}
                                    >
                                        Tiêu đề :
                                    </strong>
                                    <p
                                        style={{
                                            display: "contents",
                                            margin: "0px"
                                        }}
                                    >
                                        {issue.subject}
                                    </p>
                                </div>

                                <div
                                    style={{
                                        paddingTop: "5px"
                                    }}
                                >
                                    <strong
                                        style={{
                                            display: "inline-flex",
                                            paddingRight: "10px"
                                        }}
                                    >
                                        NV kĩ thuật :
                                    </strong>
                                    <p
                                        style={{
                                            display: "contents",
                                            margin: "0px"
                                        }}
                                    >
                                        {this.getHeaderName(issue.assignedToID)}
                                    </p>
                                </div>

                                <div
                                    style={{
                                        paddingTop: "5px"
                                    }}
                                >
                                    <strong
                                        style={{
                                            display: "inline-flex",
                                            paddingRight: "10px"
                                        }}
                                    >
                                        NV kinh doanh :
                                    </strong>
                                    <p
                                        style={{
                                            display: "contents",
                                            margin: "0px"
                                        }}
                                    >
                                        {this.getHeaderName(issue.saleID)}
                                    </p>
                                </div>

                                <div
                                    style={{
                                        paddingTop: "5px"
                                    }}
                                >
                                    <strong
                                        style={{
                                            display: "inline-flex",
                                            paddingRight: "10px"
                                        }}
                                    >
                                        Thời gian :
                                    </strong>
                                    <p
                                        style={{
                                            display: "contents",
                                            margin: "0px"
                                        }}
                                    >
                                        {issue.startTime}
                                    </p>
                                </div>

                                <div
                                    style={{
                                        paddingTop: "5px"
                                    }}
                                >
                                    <strong
                                        style={{
                                            display: "inline-flex",
                                            paddingRight: "10px"
                                        }}
                                    >
                                        Đia Chỉ :
                                    </strong>
                                    <p
                                        style={{
                                            display: "contents",
                                            margin: "0px"
                                        }}
                                    >
                                        {issue.clientAddress}
                                    </p>
                                </div>
                            </div>

                            <div>
                                <Button
                                    onClick={this.nextSuggest}
                                    style={{
                                        float: "right",
                                        border: "none",
                                        position: "relative",
                                        padding: "10px"
                                    }}
                                >
                                    Tiếp theo<Icon type="right" />
                                </Button>
                                <Button
                                    onClick={this.assignedSuggest}
                                    style={{
                                        border: "none",
                                        position: "relative",
                                        padding: "10px"
                                    }}
                                >
                                    Gán cho
                                    <strong>
                                        {this.getHeaderName(issue.assignedToID)}
                                    </strong>
                                </Button>
                            </div>
                        </div>
                    </Popup>
                </MarkerOpenPopup>
            );
        }

        let user = this.props.usersMap.filter(userMap => {
            if (userMap.get("deviceID") === this.state.suggest.id) {
                return userMap;
            }
        });

        if (user && user.size > 0) {
            user = user.toArray();

            if (user[0].get("color")) {
                color = user[0].get("color");
            }
        }

        let roadmap;
        let roadmaps = this.state.suggest.roadmaps;

        if (roadmaps && roadmaps.length > 0) {
            roadmap = roadmaps[roadmaps.length - 1];
        }

        if (!this.state.suggest.realKm) {
            let roadmap;
            let roadmaps = this.state.suggest.roadmaps;

            if (roadmaps && roadmaps.length > 0) {
                roadmap = roadmaps[roadmaps.length - 1];
            }

            if (roadmap && roadmap.latitude && roadmap.longitude) {
                let start = new google.maps.LatLng(
                    roadmap.latitude,
                    roadmap.longitude
                );

                if (!this.state.suggest.realKm && !this.state.waitingRoute) {
                    this.setState({ waitingRoute: true });
                    this.routeDirections(start, end);
                    this.getSuggestAddress(roadmap.latitude, roadmap.longitude);
                }
            }
        }

        return (
            <MarkerOpenPopup
                key={this.state.suggest.id}
                ref="marker"
                icon={this.getStatusIcon(this.state.suggest.status)}
                position={[
                    this.state.suggest.latitude,
                    this.state.suggest.longitude
                ]}
            >
                <Tooltip
                    className="tech-tooltip"
                    direction="center"
                    offset={[-30, 49]}
                    opacity={1}
                    permanent
                >
                    <p
                        style={{
                            width: "50px",
                            height: "30px",
                            color: "#fff",
                            whiteSpace: "pre-line",
                            fontSize: "11px",
                            textAlign: "center",
                            padding: "2px 5px",
                            fontWeight: 600,
                            lineHeight: "1.2em",
                            textTransform: "uppercase"
                        }}
                    >
                        {this.getTechName(this.state.suggest.id)}
                    </p>
                </Tooltip>

                <Popup ref={"popupMarker"}>
                    <div
                        style={{
                            width: "301px"
                        }}
                    >
                        <div
                            style={{
                                background: color,
                                padding: "3px",
                                textAlign: "center",
                                color: "#fff",
                                borderTopLeftRadius: "4px",
                                borderTopRightRadius: "4px",
                                fontWeight: 600
                            }}
                        >
                            {this.state.suggest.realKm}
                            - {this.state.suggest.duration}
                        </div>

                        <div
                            style={{
                                padding: "10px 10px 0px 10px"
                            }}
                        >
                            <div
                                style={{
                                    paddingTop: "5px"
                                }}
                            >
                                <strong
                                    style={{
                                        display: "inline-flex",
                                        paddingRight: "10px"
                                    }}
                                >
                                    Trang thái :
                                </strong>
                                <p
                                    style={{
                                        display: "inline-flex",
                                        margin: "0px"
                                    }}
                                >
                                    {roadmap
                                        ? `${this.getStatusName(
                                              roadmap.status
                                          )} - ${roadmap.duration}`
                                        : ""}
                                </p>
                            </div>
                            <div
                                style={{
                                    paddingTop: "5px"
                                }}
                            >
                                <strong
                                    style={{
                                        display: "inline-flex",
                                        paddingRight: "10px"
                                    }}
                                >
                                    Địa chỉ :
                                </strong>
                                <p
                                    style={{
                                        display: "contents",
                                        margin: "0px"
                                    }}
                                >
                                    {this.state.suggest.address
                                        ? this.state.suggest.address
                                        : ""}
                                </p>
                            </div>
                        </div>

                        <div>
                            <Button
                                onClick={this.nextSuggest}
                                style={{
                                    float: "right",
                                    border: "none",
                                    position: "relative",
                                    padding: "10px"
                                }}
                            >
                                Tiếp theo<Icon type="right" />
                            </Button>
                            <Button
                                onClick={this.assignedSuggest}
                                style={{
                                    border: "none",
                                    position: "relative",
                                    padding: "10px"
                                }}
                            >
                                Gán cho
                                <strong>
                                    {this.getTechName(this.state.suggest.id)}
                                </strong>
                            </Button>
                        </div>
                    </div>
                </Popup>
            </MarkerOpenPopup>
        );
    }

    getSuggestAddress(latitude, longitude) {
        let geocoder = new google.maps.Geocoder();
        let latlng = {
            lat: latitude,
            lng: longitude
        };

        geocoder.geocode(
            {
                location: latlng
            },
            (results, status) => {
                if (status === "OK") {
                    if (results[0]) {
                        let suggest = this.state.suggest;

                        suggest.address = results[0].formatted_address;

                        this.setState({ suggest });
                    }
                }
            }
        );
    }

    routeDirections(start, end) {
        let directionsService = new google.maps.DirectionsService();
        directionsService.route(
            {
                origin: start,
                destination: end,
                travelMode: "DRIVING"
            },
            (response, status) => {
                if (status === "OK") {
                    if (response && response.routes) {
                        let suggest = this.state.suggest;
                        let route = response.routes[0];
                        let polyline = [];

                        if (route["legs"] && route["legs"].length > 0) {
                            const legs = route["legs"][0];

                            if (legs.distance) {
                                suggest.realKm = legs.distance.text;
                            }

                            if (legs.duration) {
                                suggest.duration = legs.duration.text;
                            }

                            if (
                                route["overview_path"] &&
                                route["overview_path"].length > 0
                            ) {
                                route["overview_path"].map(location => {
                                    if (location && location !== null) {
                                        polyline.push([
                                            location.lat(),
                                            location.lng()
                                        ]);
                                    }
                                });
                            }
                        }

                        suggest.route = route;
                        suggest.polyline = polyline;

                        this.setState({ suggest, waitingRoute: false });
                    }
                } else {
                    this.setState({ waitingRoute: false });
                }
            }
        );
    }

    assignedSuggest = () => {
        let user;
        if (this.state.suggest.type === "tech") {
            let userMap = this.props.usersMap.filter(userMap => {
                if (userMap.get("deviceID") === this.state.suggest.id) {
                    return userMap;
                }
            });

            if (userMap && userMap.size > 0) {
                user = userMap.toArray();
            }
        } else {
            let assignedID = this.state.suggest.assignedToID
                ? this.state.suggest.assignedToID
                : 0;
            if (assignedID > 0) {
                user = [this.props.usersMap.get(assignedID.toString())];
            }
        }

        if (user && user.length > 0) {
            let userTech = user[0].toJS();
            let userID = userTech.id;
            let name = userTech.firstname;

            this.handleChange(
                [
                    {
                        key: userID.toString(),
                        label: name
                    }
                ],
                "assignedToID"
            );

            this.saveEvent(userID);
        }
    };

    handlerButtonSave() {
        let accountID = this.props.account.user.id;
        let engineerMore = this.props.slot.engineerMore
            ? this.props.slot.engineerMore
            : "";

        if (
            parseInt(this.props.account.user.id) ===
            parseInt(this.props.slot.engineerID)
        ) {
            return true;
        }

        if (engineerMore.length > 0) {
            let arrEngineerMore = engineerMore.split(",");

            if (arrEngineerMore && arrEngineerMore.length > 0) {
                return arrEngineerMore.map(engineerID => {
                    if (parseInt(engineerID) === accountID) {
                        if (
                            this.props.slot.assignedToID > 0 &&
                            this.props.slot.statusID === 8
                        ) {
                            return false;
                        }

                        return true;
                    }
                });
            }
        }

        if (
            parseInt(this.props.account.user.id) ===
            parseInt(this.props.slot.saleID)
        ) {
            return true;
        }

        if (this.cantAccess(this.state.authorID)) {
            return true;
        }

        return false;
    }

    engineerSaveAccess() {
        let accountID = this.props.account.user.id;
        let engineerID = this.props.slot.engineerID
            ? this.props.slot.engineerID
            : 0;
        let engineerMore = this.props.slot.engineerMore
            ? this.props.slot.engineerMore
            : "";

        if (accountID === engineerID) {
            if (
                !this.props.slot.assignedToID ||
                this.props.slot.assignedToID === 0
            ) {
                return true;
            }
        }

        if (engineerMore.length > 0) {
            let arrEngineerMore = engineerMore.split(",");

            if (arrEngineerMore && arrEngineerMore.length > 0) {
                return arrEngineerMore.map(engineerID => {
                    if (parseInt(engineerID) === accountID) {
                        if (
                            this.props.slot.assignedToID > 0 &&
                            this.props.slot.statusID === 8
                        ) {
                            return false;
                        }
                        return true;
                    }
                });
            }
        }

        return false;
    }

    saleSaveAccess() {
        if (
            parseInt(this.props.account.user.id) ===
            parseInt(this.props.slot.saleID)
        ) {
            if (
                !this.props.slot.assignedToID ||
                this.props.slot.assignedToID === 0
            ) {
                return true;
            }
        }

        return false;
    }

    engineerHandleAccess() {
        if (!this.props.slot.id || this.props.slot.id === 0) {
            return true;
        }

        let user = this.props.account.user;
        if (!user.groups || user.groups === null || user.groups.length === 0) {
            return false;
        }

        let isManager = user.groups["Manager"] ? true : false;
        if (isManager) {
            return true;
        }

        let isTechnical = user.groups["Technical"] ? true : false;
        if (isTechnical) {
            return false;
        }

        let iEngineer = user.groups["Engineer"] ? true : false;
        if (iEngineer) {
            return true;
        }

        let isSeller = user.groups["Seller"] ? true : false;
        if (isSeller) {
            if (
                this.props.slot.statusID === 1 ||
                this.props.slot.statusID === 0
            ) {
                return true;
            }
        }

        return false;
    }

    handlerButtonSms() {
        if (!this.state.contentSMS) {
            return true;
        }

        if (this.state.contentSMS.length >= 160) {
            return true;
        }

        if (this.state.wailtingSendSms) {
            return true;
        }

        return false;
    }

    render(s) {
        s = s || "sider-none-block";
        const formItemLayout = {
            labelCol: {
                span: 4
            },
            wrapperCol: {
                span: 18
            }
        };

        const users = this.props.usersMap
            .filter(user => user.get("firstname"))
            .toArray();
        const account = this.props.account.user;

        return (
            <Layout
                style={{
                    height: "100%",
                    position: "relative",
                    paddingBottom: this.props.styleBottom
                        ? this.props.styleBottom
                        : "80px",
                    top: "0px"
                }}
            >
                <Layout
                    style={{
                        background: "white",
                        boxShadow:
                            "rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px"
                    }}
                >
                    <Content>
                        <Tabs
                            onChange={tabIndex => {
                                if (
                                    parseInt(tabIndex) === 2 ||
                                    parseInt(tabIndex) === 3
                                ) {
                                    this.initHistory();
                                }
                                this.setState({
                                    currentTab: parseInt(tabIndex)
                                });
                            }}
                            tabBarStyle={{
                                marginBottom: "25px"
                            }}
                            defaultActiveKey="1"
                        >
                            <TabPane tab="Thông Tin" key="1">
                                <Spin spinning={this.state.loading}>
                                    <div
                                        className={"popup-issue"}
                                        style={{
                                            minHeight: "500px"
                                        }}
                                    >
                                        <Form layout={"horizontal"}>
                                            <FormItem
                                                style={{
                                                    marginBottom: "14px"
                                                }}
                                                label={
                                                    <strong> Nhân Viên</strong>
                                                }
                                                {...formItemLayout}
                                            >
                                                <Input.Group
                                                    compact
                                                    style={{
                                                        display:
                                                            this.state
                                                                .statusID ===
                                                                1 ||
                                                            this.state
                                                                .statusID === 8
                                                                ? "flex"
                                                                : "none",
                                                        width: "100%",
                                                        marginRight: "4%",
                                                        marginBottom: "10px",
                                                        marginTop: "4px"
                                                    }}
                                                >
                                                    <Button
                                                        style={{
                                                            color: "#fff",
                                                            backgroundColor:
                                                                "#039BE5",
                                                            borderColor:
                                                                "#039BE5",
                                                            minWidth: "92px"
                                                        }}
                                                    >
                                                        Kĩ Sư
                                                    </Button>
                                                    <Select
                                                        disabled={
                                                            !this.engineerHandleAccess()
                                                        }
                                                        className={
                                                            "filter-select"
                                                        }
                                                        style={{
                                                            textAlign: "left"
                                                        }}
                                                        labelInValue
                                                        defaultValue={this.getEngineerDefault()}
                                                        mode="multiple"
                                                        optionFilterProp={
                                                            "label"
                                                        }
                                                        placeholder="Chọn nhân viên"
                                                        onChange={value =>
                                                            this.handleChange(
                                                                value,
                                                                "engineerID"
                                                            )
                                                        }
                                                    >
                                                        {users.map(userMap => {
                                                            const user = userMap.toObject();
                                                            if (
                                                                user.groupId &&
                                                                user.groupId ===
                                                                    75
                                                            ) {
                                                                return (
                                                                    <Select.Option
                                                                        disabled={
                                                                            user.firstname
                                                                                ? false
                                                                                : true
                                                                        }
                                                                        key={
                                                                            user.firstname
                                                                                ? user.firstname.toLowerCase()
                                                                                : ""
                                                                        }
                                                                        value={user.id.toString()}
                                                                        label={
                                                                            user.firstname
                                                                                ? user.firstname.toLowerCase()
                                                                                : ""
                                                                        }
                                                                    >
                                                                        {parseUsername(
                                                                            user.firstname,
                                                                            user.lastname
                                                                        )}
                                                                    </Select.Option>
                                                                );
                                                            } else {
                                                                return (
                                                                    <Select.Option
                                                                        style={{
                                                                            display:
                                                                                "none"
                                                                        }}
                                                                        disabled={
                                                                            true
                                                                        }
                                                                        key={
                                                                            user.firstname
                                                                                ? user.firstname.toLowerCase()
                                                                                : ""
                                                                        }
                                                                        value={user.id.toString()}
                                                                        label={
                                                                            user.firstname
                                                                                ? user.firstname.toLowerCase()
                                                                                : ""
                                                                        }
                                                                    >
                                                                        {
                                                                            user.firstname
                                                                        }
                                                                    </Select.Option>
                                                                );
                                                            }
                                                        })}
                                                    </Select>
                                                </Input.Group>
                                                <Input.Group
                                                    compact
                                                    style={{
                                                        display:
                                                            this.state
                                                                .statusID !==
                                                                1 &&
                                                            this.state
                                                                .statusID !== 8
                                                                ? "flex"
                                                                : "none",
                                                        width: "100%",
                                                        minWidth: "48%",
                                                        marginRight: "4%",
                                                        marginTop: "4px",
                                                        marginBottom: "10px"
                                                    }}
                                                >
                                                    <Button
                                                        style={{
                                                            color: "#fff",
                                                            backgroundColor:
                                                                "#039BE5",
                                                            borderColor:
                                                                "#039BE5",
                                                            minWidth: "92px"
                                                        }}
                                                    >
                                                        Kĩ Thuật
                                                    </Button>
                                                    <Select
                                                        className={
                                                            "filter-select"
                                                        }
                                                        disabled={
                                                            !this.cantAccess(
                                                                this.state
                                                                    .authorID,
                                                                true
                                                            )
                                                        }
                                                        style={{
                                                            textAlign: "left"
                                                        }}
                                                        labelInValue
                                                        value={
                                                            this.state
                                                                .assignedToID
                                                                ? this.userDefaultValue()
                                                                : undefined
                                                        }
                                                        mode="multiple"
                                                        optionFilterProp={
                                                            "label"
                                                        }
                                                        placeholder="Chọn nhân viên"
                                                        onChange={value =>
                                                            this.handleChange(
                                                                value,
                                                                "assignedToID"
                                                            )
                                                        }
                                                    >
                                                        {users.map(userMap => {
                                                            const user = userMap.toObject();
                                                            if (
                                                                user.groupId &&
                                                                user.groupId ===
                                                                    57
                                                            ) {
                                                                return (
                                                                    <Select.Option
                                                                        disabled={
                                                                            user.firstname
                                                                                ? false
                                                                                : true
                                                                        }
                                                                        key={
                                                                            user.firstname
                                                                                ? user.firstname.toLowerCase()
                                                                                : ""
                                                                        }
                                                                        value={user.id.toString()}
                                                                        label={
                                                                            user.firstname
                                                                                ? user.firstname.toLowerCase()
                                                                                : ""
                                                                        }
                                                                    >
                                                                        {parseUsername(
                                                                            user.firstname,
                                                                            user.lastname
                                                                        )}
                                                                    </Select.Option>
                                                                );
                                                            } else {
                                                                return (
                                                                    <Select.Option
                                                                        style={{
                                                                            display:
                                                                                "none"
                                                                        }}
                                                                        disabled={
                                                                            true
                                                                        }
                                                                        key={
                                                                            user.firstname
                                                                                ? user.firstname.toLowerCase()
                                                                                : ""
                                                                        }
                                                                        value={user.id.toString()}
                                                                        label={
                                                                            user.firstname
                                                                                ? user.firstname.toLowerCase()
                                                                                : ""
                                                                        }
                                                                    >
                                                                        {
                                                                            user.firstname
                                                                        }
                                                                    </Select.Option>
                                                                );
                                                            }
                                                        })}
                                                    </Select>
                                                </Input.Group>
                                                <Input.Group
                                                    compact
                                                    style={{
                                                        display: "flex",
                                                        width: "auto",
                                                        minWidth: "48%"
                                                    }}
                                                >
                                                    <Button
                                                        style={{
                                                            color: "#fff",
                                                            backgroundColor:
                                                                "#039BE5",
                                                            borderColor:
                                                                "#039BE5",
                                                            minWidth: "92px"
                                                        }}
                                                    >
                                                        Kinh Doanh
                                                    </Button>
                                                    <Select
                                                        className={
                                                            "filter-select"
                                                        }
                                                        disabled={
                                                            !this.saleAccess()
                                                        }
                                                        style={{
                                                            textAlign: "left"
                                                        }}
                                                        labelInValue
                                                        defaultValue={
                                                            this.state.saleID &&
                                                            this.state.saleID >
                                                                0
                                                                ? this.saleDefaultValue()
                                                                : undefined
                                                        }
                                                        mode="tags"
                                                        optionFilterProp={
                                                            "label"
                                                        }
                                                        placeholder="Chọn nhân viên"
                                                        onChange={value =>
                                                            this.handleChange(
                                                                value,
                                                                "saleID"
                                                            )
                                                        }
                                                    >
                                                        {users.map(userMap => {
                                                            const user = userMap.toObject();
                                                            if (
                                                                user.groupId &&
                                                                user.groupId ===
                                                                    34
                                                            ) {
                                                                return (
                                                                    <Select.Option
                                                                        disabled={
                                                                            !user.firstname
                                                                        }
                                                                        key={
                                                                            user.firstname
                                                                                ? user.firstname.toLowerCase()
                                                                                : ""
                                                                        }
                                                                        value={user.id.toString()}
                                                                        label={
                                                                            user.firstname
                                                                                ? user.firstname.toLowerCase()
                                                                                : ""
                                                                        }
                                                                    >
                                                                        {parseUsername(
                                                                            user.firstname,
                                                                            user.lastname
                                                                        )}
                                                                    </Select.Option>
                                                                );
                                                            } else if (
                                                                user.groupId &&
                                                                user.groupId ===
                                                                    74 &&
                                                                user.id ===
                                                                    account.id
                                                            ) {
                                                                return (
                                                                    <Select.Option
                                                                        disabled={
                                                                            !user.firstname
                                                                        }
                                                                        key={
                                                                            user.firstname
                                                                                ? user.firstname.toLowerCase()
                                                                                : ""
                                                                        }
                                                                        value={user.id.toString()}
                                                                        label={
                                                                            user.firstname
                                                                                ? user.firstname.toLowerCase()
                                                                                : ""
                                                                        }
                                                                    >
                                                                        {parseUsername(
                                                                            user.firstname,
                                                                            user.lastname
                                                                        )}
                                                                    </Select.Option>
                                                                );
                                                            } else {
                                                                return (
                                                                    <Select.Option
                                                                        style={{
                                                                            display:
                                                                                "none"
                                                                        }}
                                                                        disabled={
                                                                            true
                                                                        }
                                                                        key={
                                                                            user.firstname
                                                                                ? user.firstname.toLowerCase()
                                                                                : ""
                                                                        }
                                                                        value={user.id.toString()}
                                                                        label={
                                                                            user.firstname
                                                                                ? user.firstname.toLowerCase()
                                                                                : ""
                                                                        }
                                                                    >
                                                                        {
                                                                            user.firstname
                                                                        }
                                                                    </Select.Option>
                                                                );
                                                            }
                                                        })}
                                                    </Select>
                                                </Input.Group>
                                            </FormItem>

                                            <FormItem
                                                label={<strong> Vấn đề</strong>}
                                                {...formItemLayout}
                                            >
                                                <Select
                                                    size={"large"}
                                                    style={{
                                                        textAlign: "left"
                                                    }}
                                                    mode="tags"
                                                    labelInValue
                                                    defaultValue={
                                                        this.state.trackerID
                                                            ? this.trackerDefaultValue()
                                                            : undefined
                                                    }
                                                    optionFilterProp={"label"}
                                                    placeholder="Chọn vấn đề"
                                                    onChange={value =>
                                                        this.handleChange(
                                                            value,
                                                            "trackerID"
                                                        )
                                                    }
                                                    filterOption={(
                                                        input,
                                                        option
                                                    ) =>
                                                        option.props.children
                                                            .toLowerCase()
                                                            .indexOf(
                                                                input.toLowerCase()
                                                            ) >= 0
                                                    }
                                                >
                                                    {this.props.overviewByTrackers.map(
                                                        tracker => {
                                                            return (
                                                                <Select.Option
                                                                    key={
                                                                        tracker.trackerID
                                                                    }
                                                                >
                                                                    {
                                                                        tracker.name
                                                                    }
                                                                </Select.Option>
                                                            );
                                                        }
                                                    )}
                                                </Select>
                                            </FormItem>

                                            <FormItem
                                                label={
                                                    <strong> Trạng thái</strong>
                                                }
                                                {...formItemLayout}
                                            >
                                                {this.cantAccess(
                                                    this.state.authorID,
                                                    true
                                                ) ? (
                                                    <span>
                                                        <Select
                                                            size={"large"}
                                                            className={
                                                                "popup-select-status"
                                                            }
                                                            style={{
                                                                textAlign:
                                                                    "left",
                                                                width: "100%"
                                                            }}
                                                            labelInValue
                                                            defaultValue={
                                                                this.state
                                                                    .statusID
                                                                    ? this.statusDefaultValue(
                                                                          this
                                                                              .state
                                                                              .statusID
                                                                      )
                                                                    : {
                                                                          key:
                                                                              "1",
                                                                          label:
                                                                              "Chờ duyệt"
                                                                      }
                                                            }
                                                            optionFilterProp={
                                                                "label"
                                                            }
                                                            placeholder="Chọn trạng thái"
                                                            onChange={value =>
                                                                this.handleChange(
                                                                    value,
                                                                    "statusID"
                                                                )
                                                            }
                                                            filterOption={(
                                                                input,
                                                                option
                                                            ) =>
                                                                option.props.children
                                                                    .toLowerCase()
                                                                    .indexOf(
                                                                        input.toLowerCase()
                                                                    ) >= 0
                                                            }
                                                        >
                                                            {[
                                                                1,
                                                                8,
                                                                7,
                                                                2,
                                                                3,
                                                                5
                                                            ].map(statusID => {
                                                                let status = this.statusDefaultValue(
                                                                    statusID
                                                                );
                                                                return (
                                                                    <Select.Option
                                                                        key={
                                                                            status.key
                                                                        }
                                                                    >
                                                                        {
                                                                            status.label
                                                                        }
                                                                    </Select.Option>
                                                                );
                                                            })}
                                                        </Select>
                                                    </span>
                                                ) : (
                                                    <span>
                                                        <CheckableTag
                                                            checked={
                                                                this.state
                                                                    .statusID ===
                                                                8
                                                            }
                                                            style={{
                                                                position:
                                                                    "relative"
                                                            }}
                                                            onChange={checked => {
                                                                let user = this
                                                                    .props
                                                                    .account
                                                                    .user;
                                                                let cantChange = false;
                                                                if (
                                                                    user.groups[
                                                                        "Engineer"
                                                                    ]
                                                                ) {
                                                                    if (
                                                                        this
                                                                            .state
                                                                            .engineerID ===
                                                                        user.id
                                                                    ) {
                                                                        cantChange = true;
                                                                    } else if (
                                                                        this
                                                                            .state
                                                                            .engineerMore &&
                                                                        this
                                                                            .state
                                                                            .engineerMore
                                                                            .length >
                                                                            0
                                                                    ) {
                                                                        let arrEngineerMore = this.state.engineerMore.split(
                                                                            ","
                                                                        );
                                                                        if (
                                                                            arrEngineerMore &&
                                                                            arrEngineerMore.length >
                                                                                0
                                                                        ) {
                                                                            arrEngineerMore.map(
                                                                                engineerID => {
                                                                                    if (
                                                                                        parseInt(
                                                                                            engineerID
                                                                                        ) ===
                                                                                        user.id
                                                                                    ) {
                                                                                        cantChange = true;
                                                                                    }
                                                                                }
                                                                            );
                                                                        }
                                                                    }
                                                                    if (
                                                                        cantChange
                                                                    ) {
                                                                        if (
                                                                            checked
                                                                        ) {
                                                                            let value = {
                                                                                key: 8
                                                                            };
                                                                            this.handleChange(
                                                                                value,
                                                                                "statusID"
                                                                            );
                                                                        } else {
                                                                            let value = {
                                                                                key: 1
                                                                            };
                                                                            this.handleChange(
                                                                                value,
                                                                                "statusID"
                                                                            );
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            Đang xử lý
                                                        </CheckableTag>
                                                        <Icon
                                                            type="arrow-right"
                                                            style={{
                                                                paddingRight:
                                                                    "6px"
                                                            }}
                                                        />
                                                        <CheckableTag
                                                            checked={
                                                                this.state
                                                                    .statusID ===
                                                                7
                                                            }
                                                            onChange={checked => {
                                                                let user = this
                                                                    .props
                                                                    .account
                                                                    .user;
                                                                let cantChange = false;
                                                                if (
                                                                    user.groups[
                                                                        "Engineer"
                                                                    ]
                                                                ) {
                                                                    if (
                                                                        this
                                                                            .state
                                                                            .engineerID ===
                                                                        user.id
                                                                    ) {
                                                                        cantChange = true;
                                                                    } else if (
                                                                        this
                                                                            .state
                                                                            .engineerMore &&
                                                                        this
                                                                            .state
                                                                            .engineerMore
                                                                            .length >
                                                                            0
                                                                    ) {
                                                                        let arrEngineerMore = this.state.engineerMore.split(
                                                                            ","
                                                                        );
                                                                        if (
                                                                            arrEngineerMore &&
                                                                            arrEngineerMore.length >
                                                                                0
                                                                        ) {
                                                                            arrEngineerMore.map(
                                                                                engineerID => {
                                                                                    if (
                                                                                        parseInt(
                                                                                            engineerID
                                                                                        ) ===
                                                                                        user.id
                                                                                    ) {
                                                                                        cantChange = true;
                                                                                    }
                                                                                }
                                                                            );
                                                                        }
                                                                    }
                                                                    if (
                                                                        cantChange
                                                                    ) {
                                                                        if (
                                                                            checked
                                                                        ) {
                                                                            let value = {
                                                                                key: 7
                                                                            };
                                                                            this.handleChange(
                                                                                value,
                                                                                "statusID"
                                                                            );
                                                                        } else {
                                                                            let value = {
                                                                                key: 8
                                                                            };
                                                                            this.handleChange(
                                                                                value,
                                                                                "statusID"
                                                                            );
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                            style={{
                                                                position:
                                                                    "relative"
                                                            }}
                                                        >
                                                            Bảo Trì
                                                        </CheckableTag>
                                                        <Icon
                                                            type="arrow-right"
                                                            style={{
                                                                paddingRight:
                                                                    "6px"
                                                            }}
                                                        />
                                                        <CheckableTag
                                                            checked={
                                                                this.state
                                                                    .statusID &&
                                                                this.state
                                                                    .statusID !==
                                                                    8 &&
                                                                this.state
                                                                    .statusID !==
                                                                    7 &&
                                                                this.state
                                                                    .statusID !==
                                                                    1
                                                            }
                                                            style={{
                                                                position:
                                                                    "relative"
                                                            }}
                                                            onChange={checked => {
                                                                let user = this
                                                                    .props
                                                                    .account
                                                                    .user;
                                                                let cantChange = false;

                                                                if (
                                                                    user.groups[
                                                                        "Engineer"
                                                                    ]
                                                                ) {
                                                                    if (
                                                                        this
                                                                            .state
                                                                            .engineerID ===
                                                                        user.id
                                                                    ) {
                                                                        cantChange = true;
                                                                    } else if (
                                                                        this
                                                                            .state
                                                                            .engineerMore &&
                                                                        this
                                                                            .state
                                                                            .engineerMore
                                                                            .length >
                                                                            0
                                                                    ) {
                                                                        let arrEngineerMore = this.state.engineerMore.split(
                                                                            ","
                                                                        );
                                                                        if (
                                                                            arrEngineerMore &&
                                                                            arrEngineerMore.length >
                                                                                0
                                                                        ) {
                                                                            arrEngineerMore.map(
                                                                                engineerID => {
                                                                                    if (
                                                                                        parseInt(
                                                                                            engineerID
                                                                                        ) ===
                                                                                        user.id
                                                                                    ) {
                                                                                        cantChange = true;
                                                                                    }
                                                                                }
                                                                            );
                                                                        }
                                                                    }
                                                                    if (
                                                                        cantChange
                                                                    ) {
                                                                        if (
                                                                            checked
                                                                        ) {
                                                                            let value = {
                                                                                key: 3
                                                                            };
                                                                            this.handleChange(
                                                                                value,
                                                                                "statusID"
                                                                            );
                                                                        } else {
                                                                            let value = {
                                                                                key: 7
                                                                            };
                                                                            this.handleChange(
                                                                                value,
                                                                                "statusID"
                                                                            );
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            {this.state
                                                                .statusID &&
                                                            this.state
                                                                .statusID !==
                                                                1 &&
                                                            this.state
                                                                .statusID !==
                                                                8 &&
                                                            this.state
                                                                .statusID !== 7
                                                                ? this.statusDefaultValue(
                                                                      this.state
                                                                          .statusID,
                                                                      true
                                                                  )
                                                                : "Hoàn Thành"}
                                                        </CheckableTag>
                                                    </span>
                                                )}
                                            </FormItem>

                                            {this.props.slot.statusID ===
                                            8 ? null : (
                                                <FormItem
                                                    label={
                                                        <strong>
                                                            {" "}
                                                            Thời gian
                                                        </strong>
                                                    }
                                                    {...formItemLayout}
                                                >
                                                    <Input.Group
                                                        compact
                                                        style={{
                                                            display: "flex",
                                                            width: "100%",
                                                            marginRight: "4%",
                                                            marginBottom:
                                                                "10px",
                                                            marginTop: "4px"
                                                        }}
                                                    >
                                                        <DatePicker
                                                            defaultValue={moment(
                                                                this.state
                                                                    .start,
                                                                "DD-MM-YYYY"
                                                            )}
                                                            format={
                                                                "DD-MM-YYYY"
                                                            }
                                                            size={"large"}
                                                            disabledTime
                                                            style={{
                                                                width: "100%"
                                                            }}
                                                            onChange={(
                                                                date,
                                                                dateString
                                                            ) =>
                                                                this.handleChange(
                                                                    date,
                                                                    "startDate"
                                                                )
                                                            }
                                                        />

                                                        <TimeInput
                                                            className="popover-time form-control"
                                                            initTime={moment(
                                                                this.state.start
                                                            ).format("HH:mm")}
                                                            ref="TimeInputWrapper"
                                                            onTimeChange={value =>
                                                                this.handleChange(
                                                                    value,
                                                                    "startTime"
                                                                )
                                                            }
                                                        />

                                                        <TimeInput
                                                            className="popover-time popover-time-left form-control"
                                                            initTime={`${this.addZero(
                                                                this.state.end.getHours()
                                                            )}:${this.addZero(
                                                                this.state.end.getMinutes()
                                                            )}`}
                                                            ref="TimeInputWrapper"
                                                            onTimeChange={value =>
                                                                this.handleChange(
                                                                    value,
                                                                    "dueTime"
                                                                )
                                                            }
                                                        />
                                                    </Input.Group>
                                                </FormItem>
                                            )}

                                            <FormItem
                                                label={
                                                    <strong> Tài Khoản</strong>
                                                }
                                                {...formItemLayout}
                                            >
                                                <SelectUser
                                                    handleChange={
                                                        this.handleChange
                                                    }
                                                    token={this.props.token}
                                                    projectID={
                                                        this.props.curProjectID
                                                    }
                                                    username={
                                                        this.state.username
                                                    }
                                                    clientID={
                                                        this.state.clientID
                                                    }
                                                    clientDetailID={
                                                        this.state
                                                            .clientDetailID
                                                    }
                                                    clientAddress={
                                                        this.state.clientAddress
                                                    }
                                                    contactName={
                                                        this.state.contactName
                                                    }
                                                    contactPhone={
                                                        this.state.contactPhone
                                                    }
                                                    setSelectedUserID={
                                                        this.setSelectedUserID
                                                    }
                                                />
                                                <div
                                                    style={{
                                                        backgroundColor:
                                                            "#f7f7f7",
                                                        paddingTop: "10px",
                                                        paddingBottom: "3px",
                                                        paddingLeft: "22px",
                                                        display: this.state
                                                            .saveClientDetail
                                                            ? "block"
                                                            : "none"
                                                    }}
                                                >
                                                    <FormItem
                                                        style={{
                                                            marginBottom: "10px"
                                                        }}
                                                        label={
                                                            <strong>
                                                                {" "}
                                                                Liên Hệ
                                                            </strong>
                                                        }
                                                        {...formItemLayout}
                                                    >
                                                        <Input
                                                            onChange={value =>
                                                                this.handleChange(
                                                                    value,
                                                                    "contactName"
                                                                )
                                                            }
                                                            placeholder="Tên người liên hệ"
                                                            maxLength="50"
                                                            value={
                                                                this.state
                                                                    .contactName
                                                                    ? this.state
                                                                          .contactName
                                                                    : ""
                                                            }
                                                        />
                                                    </FormItem>

                                                    <FormItem
                                                        style={{
                                                            marginBottom: "10px"
                                                        }}
                                                        label={
                                                            <strong>
                                                                {" "}
                                                                Điện Thoại
                                                            </strong>
                                                        }
                                                        {...formItemLayout}
                                                    >
                                                        <Input
                                                            onChange={value =>
                                                                this.handleChange(
                                                                    value,
                                                                    "contactPhone"
                                                                )
                                                            }
                                                            placeholder="Số điện thoại"
                                                            maxLength="11"
                                                            value={
                                                                this.state
                                                                    .contactPhone
                                                                    ? this.state
                                                                          .contactPhone
                                                                    : ""
                                                            }
                                                        />
                                                    </FormItem>

                                                    <FormItem
                                                        style={{
                                                            marginBottom: "10px"
                                                        }}
                                                        label={
                                                            <strong>
                                                                {" "}
                                                                Địa chỉ
                                                            </strong>
                                                        }
                                                        {...formItemLayout}
                                                    >
                                                        <PlacesAutocomplete
                                                            onSelect={
                                                                this
                                                                    .handleSelect
                                                            }
                                                            onEnterKeyDown={
                                                                this
                                                                    .handleSelect
                                                            }
                                                            inputProps={{
                                                                value: this
                                                                    .state
                                                                    .clientAddress
                                                                    ? this.state
                                                                          .clientAddress
                                                                    : "",
                                                                onChange: value =>
                                                                    this.handleChange(
                                                                        value,
                                                                        "clientAddress"
                                                                    ),
                                                                onBlur: value => {
                                                                    let address =
                                                                        value
                                                                            .target
                                                                            .value;
                                                                    if (
                                                                        address &&
                                                                        address.length >
                                                                            0
                                                                    ) {
                                                                        if (
                                                                            !this
                                                                                .state
                                                                                .latitude ||
                                                                            this
                                                                                .state
                                                                                .latitude ==
                                                                                0
                                                                        ) {
                                                                            this.handleSelect(
                                                                                address
                                                                            );
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                            classNames={{
                                                                autocompleteContainer:
                                                                    "autocomplete-container",
                                                                input:
                                                                    "autocomplete-input"
                                                            }}
                                                        />
                                                    </FormItem>
                                                </div>
                                            </FormItem>

                                            <FormItem
                                                label={
                                                    <strong> Thiết Bị</strong>
                                                }
                                                {...formItemLayout}
                                            >
                                                <SelectDevices
                                                    defaultDevices={
                                                        this.state
                                                            .defaultDevices
                                                    }
                                                    handleChange={
                                                        this.handleChange
                                                    }
                                                    clientID={
                                                        this.state.clientID
                                                    }
                                                />
                                            </FormItem>

                                            <FormItem
                                                label={<strong> Mô tả</strong>}
                                                {...formItemLayout}
                                            >
                                                <Input
                                                    type="textarea"
                                                    autosize={{
                                                        minRows: 4,
                                                        maxRows: 6
                                                    }}
                                                    defaultValue={
                                                        this.state.description
                                                            ? this.state
                                                                  .description
                                                            : ""
                                                    }
                                                    onChange={value =>
                                                        this.handleChange(
                                                            value,
                                                            "description"
                                                        )
                                                    }
                                                    placeholder="Nhập mô tả"
                                                />
                                            </FormItem>
                                        </Form>
                                    </div>
                                </Spin>
                            </TabPane>
                            <TabPane
                                tab="Lịch Sử"
                                key="2"
                                style={{
                                    position: "relative",
                                    paddingLeft: "20px"
                                }}
                            >
                                {this.state.history &&
                                this.state.history.length > 0 ? (
                                    <Timeline
                                        className={"history-timeline"}
                                        pending={true}
                                    >
                                        {this.state.history.map(history => {
                                            let fullName = "";
                                            let relativeTime = "";
                                            let user = this.props.usersMap.get(
                                                history.userID.toString()
                                            );

                                            if (user) {
                                                history.color = user.get(
                                                    "color"
                                                );
                                                fullName = parseUsername(
                                                    user.get("firstname"),
                                                    user.get("lastname")
                                                );
                                            }

                                            if (
                                                history.createdOn &&
                                                history.createdOn.length > 0
                                            ) {
                                                relativeTime = parseTimeFromNow(
                                                    history.createdOn
                                                );
                                            }

                                            if (history.propKey === "comment") {
                                                return (
                                                    <Timeline.Item
                                                        dot={
                                                            <Avatar
                                                                style={{
                                                                    backgroundColor: history.color
                                                                        ? history.color
                                                                        : "#f56a00"
                                                                }}
                                                                size="small"
                                                            >
                                                                {" "}
                                                                {parseAvatarText(
                                                                    fullName
                                                                ).toUpperCase()}
                                                            </Avatar>
                                                        }
                                                        key={
                                                            history.id +
                                                            history.propKey
                                                        }
                                                    >
                                                        <Card
                                                            className={
                                                                "history-comment"
                                                            }
                                                            title={
                                                                <span>
                                                                    {" "}
                                                                    <strong
                                                                    >{`${fullName} `}</strong>commented{" "}
                                                                    {
                                                                        relativeTime
                                                                    }
                                                                </span>
                                                            }
                                                            style={{
                                                                marginRight: 20,
                                                                position:
                                                                    "relative",
                                                                top: "-10px"
                                                            }}
                                                        >
                                                            {history.moreDetail
                                                                ? history.moreDetail
                                                                : null}
                                                        </Card>
                                                    </Timeline.Item>
                                                );
                                            }

                                            if (history.propKey !== "sms") {
                                                return (
                                                    <Timeline.Item
                                                        style={{
                                                            top: "-10px"
                                                        }}
                                                        key={
                                                            history.id +
                                                            history.propKey
                                                        }
                                                    >
                                                        <p>
                                                            Updated by
                                                            <strong
                                                            >{` ${fullName} `}</strong>
                                                            {relativeTime}
                                                        </p>
                                                        {history.moreDetail
                                                            ? history.moreDetail
                                                            : null}
                                                    </Timeline.Item>
                                                );
                                            }

                                            return (
                                                <Timeline.Item
                                                    style={{
                                                        display: "none"
                                                    }}
                                                    key={
                                                        history.id +
                                                        history.propKey
                                                    }
                                                />
                                            );
                                        })}
                                    </Timeline>
                                ) : null}
                            </TabPane>
                            <TabPane
                                tab="Tin Nhắn"
                                key="3"
                                style={{
                                    position: "relative",
                                    paddingLeft: "20px"
                                }}
                            >
                                {this.state.history &&
                                this.state.history.length > 0 ? (
                                    <Timeline pending={true}>
                                        {this.state.history.map(history => {
                                            let fullName = "";
                                            let relativeTime = "";
                                            let user = this.props.usersMap.get(
                                                history.userID.toString()
                                            );

                                            if (user) {
                                                history.color = user.get(
                                                    "color"
                                                );
                                                fullName = parseUsername(
                                                    user.get("firstname"),
                                                    user.get("lastname")
                                                );
                                            }

                                            if (
                                                history.createdOn &&
                                                history.createdOn.length > 0
                                            ) {
                                                relativeTime = parseTimeFromNow(
                                                    history.createdOn
                                                );
                                            }

                                            if (history.propKey === "sms") {
                                                return (
                                                    <Timeline.Item
                                                        dot={
                                                            <Avatar
                                                                style={{
                                                                    backgroundColor: history.color
                                                                        ? history.color
                                                                        : "#f56a00"
                                                                }}
                                                                size="small"
                                                            >
                                                                {" "}
                                                                {parseAvatarText(
                                                                    fullName
                                                                ).toUpperCase()}
                                                            </Avatar>
                                                        }
                                                        key={
                                                            history.id +
                                                            history.propKey
                                                        }
                                                    >
                                                        <Card
                                                            className={
                                                                "history-comment"
                                                            }
                                                            title={
                                                                <span>
                                                                    {" "}
                                                                    <p
                                                                        style={{
                                                                            float:
                                                                                "left"
                                                                        }}
                                                                    >
                                                                        <strong
                                                                        >{`${fullName} `}</strong>
                                                                        send sms{" "}
                                                                        {
                                                                            relativeTime
                                                                        }
                                                                    </p>{" "}
                                                                    <p
                                                                        style={{
                                                                            float:
                                                                                "right",
                                                                            fontSize:
                                                                                "12px",
                                                                            fontStyle:
                                                                                "italic"
                                                                        }}
                                                                    >
                                                                        {" "}
                                                                        {this.parseSmsStatus(
                                                                            history.smsStatus
                                                                        )}
                                                                    </p>{" "}
                                                                </span>
                                                            }
                                                            style={{
                                                                marginRight: 20,
                                                                position:
                                                                    "relative",
                                                                top: "-10px"
                                                            }}
                                                        >
                                                            {history.moreDetail
                                                                ? history.moreDetail
                                                                : null}
                                                        </Card>
                                                    </Timeline.Item>
                                                );
                                            }

                                            return (
                                                <Timeline.Item
                                                    style={{
                                                        top: "-10px",
                                                        display: "none"
                                                    }}
                                                    key={
                                                        history.id +
                                                        history.propKey
                                                    }
                                                >
                                                    <p>
                                                        Updated by
                                                        <strong
                                                        >{`${fullName} `}</strong>
                                                        {relativeTime}
                                                    </p>
                                                    {history.moreDetail
                                                        ? history.moreDetail
                                                        : null}
                                                </Timeline.Item>
                                            );
                                        })}
                                    </Timeline>
                                ) : null}
                            </TabPane>
                        </Tabs>
                    </Content>

                    {this.state.alert.map(type => {
                        if (type === "error") {
                            return (
                                <Alert
                                    message="Có lỗi xảy ra vui lòng thử lại"
                                    closeText={"close"}
                                    type="error"
                                    showIcon
                                    closable
                                />
                            );
                        }

                        return (
                            <Alert
                                message="Lưu thành công"
                                type="success"
                                closeText={"close"}
                                closable
                                showIcon
                            />
                        );
                    })}

                    <Footer
                        style={{
                            minHeight: "60px",
                            padding: "10px 10px",
                            backgroundColor: "rgba(226, 226, 226, 0.31)"
                        }}
                    >
                        {this.state.currentTab === 1 &&
                        (this.cantAccess(this.props.slot.authorID, true) ||
                            this.engineerSaveAccess() ||
                            this.saleSaveAccess() ||
                            this.state.statusID === 1) ? (
                            <span>
                                {this.handlerButtonSave() ? (
                                    <RaisedButton
                                        className={"button-loading"}
                                        disabled={this.state.wailtingSaveIssue}
                                        label="Lưu"
                                        primary={true}
                                        style={style.submitEvent}
                                        onTouchTap={event => this.saveEvent()}
                                        disabledBackgroundColor={
                                            this.state.wailtingSaveIssue
                                                ? "rgba(21, 101, 192, 0.58)"
                                                : "rgb(229, 229, 229)"
                                        }
                                        disabledLabelColor={
                                            this.state.wailtingSaveIssue
                                                ? "#fff"
                                                : "#ccc"
                                        }
                                        icon={
                                            <Icon
                                                type="loading"
                                                style={{
                                                    color: "#fff",
                                                    position: "relative",
                                                    top: "-3px",
                                                    marginLeft: "6px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    display: this.state
                                                        .wailtingSaveIssue
                                                        ? "inline-flex"
                                                        : "none"
                                                }}
                                            />
                                        }
                                    />
                                ) : null}

                                {this.cantAccess(this.state.authorID, true) &&
                                this.state.id > 0 ? (
                                    <RaisedButton
                                        className={"button-loading"}
                                        disabled={
                                            (parseInt(
                                                this.props.account.user.id
                                            ) !==
                                                parseInt(
                                                    this.props.slot.saleID
                                                ) &&
                                                !this.cantAccess(
                                                    this.state.authorID
                                                )) ||
                                            this.state.wailtingSaveIssue
                                        }
                                        label="Xoá"
                                        primary={true}
                                        style={style.deleteEvent}
                                        onTouchTap={event => this.deleteEvent()}
                                        disabledBackgroundColor={
                                            this.state.wailtingSaveIssue
                                                ? "rgba(21, 101, 192, 0.58)"
                                                : "rgb(229, 229, 229)"
                                        }
                                        disabledLabelColor={
                                            this.state.wailtingSaveIssue
                                                ? "#fff"
                                                : "#ccc"
                                        }
                                        icon={
                                            <Icon
                                                type="loading"
                                                style={{
                                                    color: "#fff",
                                                    position: "relative",
                                                    top: "-3px",
                                                    marginLeft: "6px",
                                                    fontSize: "13px",
                                                    fontWeight: "600",
                                                    display: this.state
                                                        .wailtingSaveIssue
                                                        ? "inline-flex"
                                                        : "none"
                                                }}
                                            />
                                        }
                                    />
                                ) : null}
                            </span>
                        ) : null}

                        {this.state.currentTab === 2 ? (
                            <PopupMentions
                                mentionUsers={this.state.mentionUsers}
                                devices={this.state.devices}
                                from={parseUsername(
                                    this.props.account.user.firstname,
                                    this.props.account.user.lastname
                                )}
                                engineerID={this.state.engineerID}
                                saleID={this.state.saleID}
                                usersMap={this.props.usersMap}
                                issueID={this.state.id}
                                subject={this.state.subject}
                                username={this.state.username}
                                token={this.props.token}
                                handleChange={this.handleChange}
                            />
                        ) : null}

                        {this.state.currentTab === 3 &&
                        this.cantAccess(this.state.authorID, true) ? (
                            <span
                                style={{
                                    display:
                                        this.state.id > 0 ? "block" : "none"
                                }}
                            >
                                <Input
                                    type="textarea"
                                    autosize={{
                                        minRows: 5,
                                        maxRows: 6
                                    }}
                                    placeholder="Nhập tin nhắn"
                                    onChange={value => {
                                        this.setState({
                                            contentSMS: value.target.value
                                        });
                                    }}
                                    value={this.state.contentSMS}
                                    defaultValue={this.genSms()}
                                />

                                <p
                                    style={{
                                        width: "150px",
                                        position: "absolute"
                                    }}
                                >
                                    <span
                                        style={{
                                            color:
                                                this.state.contentSMS &&
                                                this.state.contentSMS.length <
                                                    160
                                                    ? "rgb(140, 129, 129)"
                                                    : "red"
                                        }}
                                    >
                                        {this.state.contentSMS
                                            ? this.state.contentSMS.length
                                            : 0}
                                    </span>/160 kí tự
                                </p>

                                <RaisedButton
                                    className={"button-loading"}
                                    disabled={this.handlerButtonSms()}
                                    label="Nhắn Tin"
                                    primary={true}
                                    style={{
                                        float: "right",
                                        margin: "10px 0"
                                    }}
                                    onTouchTap={event => this.sendSMS()}
                                    disabledBackgroundColor={
                                        this.state.wailtingSendSms
                                            ? "rgba(21, 101, 192, 0.58)"
                                            : "rgb(229, 229, 229)"
                                    }
                                    disabledLabelColor={
                                        this.state.wailtingSendSms
                                            ? "#fff"
                                            : "#ccc"
                                    }
                                    icon={
                                        <Icon
                                            type="loading"
                                            style={{
                                                color: "#fff",
                                                position: "relative",
                                                top: "-3px",
                                                marginLeft: "6px",
                                                fontSize: "13px",
                                                fontWeight: "600",
                                                display: this.state
                                                    .wailtingSendSms
                                                    ? "inline-flex"
                                                    : "none"
                                            }}
                                        />
                                    }
                                />
                            </span>
                        ) : null}
                    </Footer>
                </Layout>
                {this.state.showMaps ? (
                    <Sider
                        className={"dialog-leftlet"}
                        style={{
                            height: "100%"
                        }}
                    >
                        <MapLeftlet
                            bounds={this.getBounds()}
                            center={position}
                            zoom={13}
                            style={{
                                height: "100%"
                            }}
                        >
                            <TileLayer url="https://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}&s=Ga" />{" "}
                            {this.state.latitude && this.state.latitude > 0 ? (
                                <MarkerOpenPopup
                                    ref="marker"
                                    draggable={this.state.saveClientDetail}
                                    onDragend={this.updatePosition}
                                    icon={Leaflet.divIcon({
                                        className: "leaftlet-div-icon",
                                        iconAnchor: [0, 24],
                                        labelAnchor: [-6, 0],
                                        popupAnchor: [0, -36],
                                        html: `<span style="background-color: #B71C1C"> <i class="material-icons">person</i> <div class="marker-icon-border"></div> </span> <div class="marker-tranform"></div> `
                                    })}
                                    position={
                                        this.state.latitude &&
                                        this.state.longitude
                                            ? [
                                                  this.state.latitude,
                                                  this.state.longitude
                                              ]
                                            : position
                                    }
                                >
                                    <Tooltip
                                        className="maps-tooltip"
                                        direction="center"
                                        offset={[-5, -10]}
                                        opacity={1}
                                        permanent
                                    >
                                        <span
                                            style={{
                                                color: "#111"
                                            }}
                                        >
                                            {this.getTooltipInfo(this.state)}
                                        </span>
                                    </Tooltip>
                                    <Popup>
                                        <span>
                                            <span
                                                style={{
                                                    width: "100%",
                                                    textAlign: "center",
                                                    background: "#B71C1C",
                                                    color: "#fff",
                                                    float: "left",
                                                    borderTopLeftRadius: "5px",
                                                    borderTopRightRadius: "5px",
                                                    padding: "5px",
                                                    fontWeight: 600,
                                                    marginBottom: "10px",
                                                    textTransform: "capitalize"
                                                }}
                                            >
                                                {this.state.contactName}
                                            </span>
                                            <span
                                                style={{
                                                    display: "block",
                                                    marginLeft: "10px",
                                                    paddingRight: "10px"
                                                }}
                                            >
                                                <strong
                                                    style={{
                                                        display: "inline-flex"
                                                    }}
                                                >
                                                    Điện Thoại:
                                                </strong>
                                                <span
                                                    style={{
                                                        marginLeft: "5px"
                                                    }}
                                                >
                                                    {this.state.contactPhone}
                                                </span>
                                            </span>
                                            <span
                                                style={{
                                                    display: "block",
                                                    marginLeft: "10px",
                                                    paddingRight: "10px"
                                                }}
                                            >
                                                <strong
                                                    style={{
                                                        display: "inline-flex"
                                                    }}
                                                >
                                                    Địa Chỉ:
                                                </strong>
                                                <span
                                                    style={{
                                                        marginLeft: "5px"
                                                    }}
                                                >
                                                    {this.state.clientAddress}
                                                </span>
                                            </span>
                                            <span
                                                style={{
                                                    display: "block",
                                                    marginLeft: "10px",
                                                    paddingRight: "10px"
                                                }}
                                            >
                                                <strong
                                                    style={{
                                                        display: "inline-flex"
                                                    }}
                                                >
                                                    Toạ Độ :
                                                </strong>
                                                <span
                                                    style={{
                                                        marginLeft: "5px",
                                                        color:
                                                            "rgb(21, 101, 192)"
                                                    }}
                                                >
                                                    {this.state.latitude},{
                                                        this.state.longitude
                                                    }
                                                </span>
                                            </span>
                                        </span>
                                    </Popup>
                                </MarkerOpenPopup>
                            ) : null}
                            {this.state.devices.map(device => {
                                let roadmaps = device.roadmaps;
                                return null;
                                if (roadmaps && roadmaps.length > 0) {
                                    if (
                                        roadmaps[0].latitude &&
                                        roadmaps[0].longitude
                                    ) {
                                        return (
                                            <Marker
                                                key={device.id}
                                                ref="marker"
                                                icon={Leaflet.divIcon({
                                                    className:
                                                        "leaftlet-div-icon",
                                                    iconAnchor: [0, 24],
                                                    labelAnchor: [-6, 0],
                                                    popupAnchor: [0, -36],
                                                    html: `<span style="background-color: ${
                                                        device.color
                                                            ? device.color
                                                            : "#ccc"
                                                    }"> <i class="material-icons">directions_car</i> <div class="marker-icon-border"></div> </span> <div class="marker-tranform"></div> `
                                                })}
                                                position={[
                                                    roadmaps[0].latitude,
                                                    roadmaps[0].longitude
                                                ]}
                                            >
                                                <Tooltip
                                                    className="maps-tooltip"
                                                    direction="center"
                                                    offset={[-5, -10]}
                                                    opacity={1}
                                                    permanent
                                                >
                                                    <span
                                                        style={{
                                                            color: "#111"
                                                        }}
                                                    >
                                                        {device.name}
                                                    </span>
                                                </Tooltip>
                                            </Marker>
                                        );
                                    }
                                }

                                return null;
                            })}
                            {this.props.slot.statusID === 7 &&
                            this.state.suggest
                                ? this.renderSuggestMarker()
                                : null}
                            {this.props.techLocation.map(location => {
                                let roadmaps = location.roadmaps;

                                if (roadmaps && roadmaps.length > 0) {
                                    if (
                                        roadmaps[0].latitude &&
                                        roadmaps[0].longitude &&
                                        this.state.viewTech &&
                                        this.state.viewTech.get(location.id)
                                    ) {
                                        return (
                                            <Marker
                                                key={location.id}
                                                ref="marker"
                                                icon={this.getStatusIcon(
                                                    roadmaps[0].status
                                                )}
                                                position={[
                                                    roadmaps[0].latitude,
                                                    roadmaps[0].longitude
                                                ]}
                                            >
                                                <Tooltip
                                                    className="tech-tooltip"
                                                    direction="center"
                                                    offset={[-30, 49]}
                                                    opacity={1}
                                                    permanent
                                                >
                                                    <p
                                                        style={{
                                                            width: "50px",
                                                            height: "30px",
                                                            color: "#fff",
                                                            whiteSpace:
                                                                "pre-line",
                                                            fontSize: "11px",
                                                            textAlign: "center",
                                                            padding: "2px 5px",
                                                            fontWeight: 600,
                                                            lineHeight: "1.2em",
                                                            textTransform:
                                                                "uppercase"
                                                        }}
                                                    >
                                                        {this.getTechName(
                                                            location.id
                                                        )}
                                                    </p>
                                                </Tooltip>
                                            </Marker>
                                        );
                                    }
                                }

                                return null;
                            })}
                            {this.state.suggest &&
                            this.state.suggest.polyline ? (
                                <Polyline
                                    positions={this.state.suggest.polyline}
                                />
                            ) : null}
                        </MapLeftlet>
                    </Sider>
                ) : (
                    <Sider
                        className={"sider-none-block"}
                        style={{
                            height: "100%"
                        }}
                    />
                )}
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/schedule/popup/popup.js